// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:05:12.274Z
// Property: The Nolan (ID: 6767906449166354)
// Collections: 20 amenities, 4 floorplans (live), 12 photos, 76 POIs, 5 reviews, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166354",
  "property_external_id": "30920",
  "property_zillow_url": "https://www.zillow.com/apartments/morrisville-pa/the-nolan/Bz2WjZ/",
  "property_apartments_url": "https://www.apartments.com/the-nolan-morrisville-pa/kgj0v68/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Nolan+Apartments/data=!4m2!3m1!1s0x0:0x9e38d07c9d57e8d0?sa=X&ved=2ahUKEwiJmIHj_riSAxUSVUEAHSpVDvgQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-nolan",
  "property_name": "The Nolan",
  "property_website_url": "https://www.thenolanapts.com/",
  "property_domain": "https://www.thenolanapts.com/",
  "property_address": "603-609 Nolan Avenue",
  "property_full_address": "603-609 Nolan Ave, Morrisville, PA 19067",
  "property_address_1": "603-609 Nolan Ave",
  "property_address_2": null,
  "property_address_city": "Morrisville",
  "property_address_state": "PA",
  "property_address_zip_full": "19067-7540",
  "property_address_zip": "19067",
  "property_address_country": "US",
  "property_address_county": "Bucks County",
  "property_neighborhood_address": "Lower Bucks County",
  "property_address_latitude": "40.2105918",
  "property_address_longitude": "-74.7927073",
  "property_email": "thenolan.pm@aionmanagement.com",
  "property_phone": "(267) 318-0069",
  "property_call_tracking_phone": "844-619-0204",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to The Nolan, where comfort meets convenience in Morrisville, PA. Choose from spacious one or two-bedroom apartments featuring beautifully landscaped grounds, pet-friendly amenities, and modern finishes. Enjoy the ease of online maintenance requests and flexible rent payments. Your ideal home awaits—check our availability or schedule a tour today!",
  "property_long_description": "Welcome to The Nolan, your ideal apartment community nestled in the heart of Morrisville, PA. We offer a range of spacious floor plans, including one and two-bedroom options designed with your comfort in mind. Each apartment showcases beautifully renovated kitchens with stainless steel appliances, in-unit washers and dryers, and ample closet space, ensuring you have everything you need right at home.\n\nExperience the luxury of our pet-friendly community, set within beautifully landscaped grounds that create a park-like atmosphere. Enjoy the convenience of ample parking and the peace of mind that comes with 24-hour emergency maintenance. Our residents benefit from modern amenities, including easy online maintenance requests and flexible rent payment options, all accessible via our user-friendly resident portal.\n\nPerfectly situated just minutes from Route 1 and I-95, commuting is a breeze. Plus, you're only 3 miles from the SEPTA Yardley Station, making it easy to connect with surrounding areas. Located within the highly regarded Pennsbury School District, The Nolan is not just a place to live; it's a community where you can thrive.\n\nOur apartments feature modern comforts, like central air conditioning, vinyl wood-style flooring, and select units equipped with dishwashers and large balconies or patios to enhance your living experience. Whether you’re relaxing in your spacious apartment or exploring our beautifully maintained grounds, you’ll find that The Nolan is the perfect place to call home.\n\nFind your new home today—browse our availability or schedule a tour to experience our community firsthand!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd912-bcf9-74ce-aaa5-3a4a8b39ac9b.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a dining area.",
    "public_id": "019fd912-bcf9-74ce-aaa5-3a4a8b39ac9b",
    "storage_key": "property/6767906449166354/019fd912-bcf9-74ce-aaa5-3a4a8b39ac9b.webp",
    "width": 1920,
    "height": 1282
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "80",
  "property_year_built": "1972",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Maximum of 2 pets per unit. No weight restrictions.",
  "property_pet_policy_description": "We’re a pet-friendly community and we’re happy to welcome your cats and dogs. Breed restrictions apply; please contact the leasing office for details. You can have up to 2 pets per apartment, with each pet up to 100 lb. There is a one-time, non-refundable pet fee of $300 and monthly pet rent is $50.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://thenolanmorrisville.loftliving.com/login",
  "property_apply_now_url": "https://www.thenolanapts.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-2846-77f8-a34d-a2618211dc3a.webp",
  "property_primary_logo_media": {
    "alt_text": "The Nolan Apartments logo",
    "public_id": "019d026c-2846-77f8-a34d-a2618211dc3a",
    "storage_key": "property/6767906449166354/019d026c-2846-77f8-a34d-a2618211dc3a.webp",
    "width": 340,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026e-14e5-77ce-a84c-99710da8ddca.webp",
  "property_secondary_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d026e-14e5-77ce-a84c-99710da8ddca",
    "storage_key": "property/6767906449166354/019d026e-14e5-77ce-a84c-99710da8ddca.webp",
    "width": 598,
    "height": 250
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026e-22b1-7516-bbcd-3ff4fea153c8.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Nolan Apartments logo",
    "public_id": "019d026e-22b1-7516-bbcd-3ff4fea153c8",
    "storage_key": "property/6767906449166354/019d026e-22b1-7516-bbcd-3ff4fea153c8.webp",
    "width": 340,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026e-2d27-7019-a5e0-c9c364156cbf.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Nolan Apartments logo",
    "public_id": "019d026e-2d27-7019-a5e0-c9c364156cbf",
    "storage_key": "property/6767906449166354/019d026e-2d27-7019-a5e0-c9c364156cbf.webp",
    "width": 340,
    "height": 160
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "800 - 1000",
  "property_sqft_min": "800",
  "property_sqft_max": "1000",
  "property_price_range": "1699 - 2025",
  "property_price_min": "1699",
  "property_price_max": "2025",
  "property_available_units": null,
  "property_facebook_url": "https://www.facebook.com/nolanapts/",
  "property_instagram_url": "https://www.instagram.com/thenolanapartments",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ4Wd1skJXwYkR0OhXnXzQOJ4",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Morrisville%2C+PA+19067",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Nolan",
  "property_home_romance_title": "Embrace Your Blissful Life at Our Charming Apartment Community",
  "property_home_amenities_blurb": "At The Nolan, nestled in picturesque Morrisville, PA, enjoy spacious one and two-bedroom homes designed for comfort and style. Revel in beautifully landscaped grounds, pet-friendly policies, and modern amenities like stainless steel appliances and in-unit laundry. Connect with your ideal living experience just minutes from Route 1 and I-95.",
  "property_home_floorplans_blurb": "At The Nolan in Morrisville, PA, our thoughtfully designed one and two-bedroom apartments offer the ideal blend of comfort and style. Nestled in a vibrant community, each floor plan invites you to live well. Browse our available homes today and let your next chapter begin in these welcoming spaces.",
  "property_home_gallery_blurb": "Welcome to The Nolan in Morrisville, PA, where your perfect home awaits. Choose from spacious one- and two-bedroom floor plans, complete with beautifully landscaped grounds and modern amenities like in-unit washers and stainless steel appliances. Embrace pet-friendly living just minutes from Route 1 and I-95. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to The Nolan, your serene oasis in Morrisville, PA! Live comfortably in our spacious one and two-bedroom floor plans, and enjoy easy access to vibrant community attractions. With parks, schools, and cultural gems like the Bucks County Playhouse just moments away, you’ll savor both convenience and charm at your doorstep.",
  "property_home_reviews_blurb": "At The Nolan in Morrisville, PA, residents rave about the seamless living experience provided by our dedicated team. One resident shares, \"Kevin makes the application process easy and has been very supportive since then.\" Join a community where comfort meets convenience, and enjoy a peaceful lifestyle that feels like home.",
  "property_neighborhood_blurb": "At The Nolan in Morrisville, PA, your vibrant lifestyle awaits amidst a rich tapestry of local attractions. Enjoy lush parks, esteemed schools, and cultural gems like the Bucks County Playhouse and the New Hope Railroad. Nearby, explore unique shops and convenient services, making everyday life a delightful adventure. ",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The Nolan in Morrisville, PA, you’ll relish the tranquil park-like setting complemented by beautifully landscaped grounds. Choose from spacious one and two-bedroom floor plans, enjoy pet-friendly amenities, and embrace modern comforts like in-unit washers and new stainless steel kitchens. Your dream apartment awaits—connect with us today!",
  "property_applynow_blurb": "At The Nolan in Morrisville, PA, you’ll find spacious one and two-bedroom apartments nestled in beautifully landscaped grounds, just minutes from Route 1 and I-95. Enjoy pet-friendly living, modern amenities, and the convenience of online rent payments. Experience comfort and style—apply now to make The Nolan your new home!",
  "property_contactus_blurb": "At The Nolan in Morrisville, PA, your ideal home awaits with thoughtfully designed one and two-bedroom floor plans. Embrace sleek modern living in a vibrant community that caters to all your needs. Have questions? Our leasing team is ready to assist—reach out today for personalized assistance!",
  "property_faqs_blurb": "At The Nolan in Morrisville, PA, we offer thoughtfully designed one and two-bedroom floor plans to suit your lifestyle. Have questions? Our FAQs page is brimming with insights to help you navigate our vibrant community and find your perfect home. Dive in to learn more about life at The Nolan!",
  "property_floorplans_blurb": "At The Nolan in Morrisville, PA, your ideal space awaits! Choose from spacious one and two-bedroom layouts designed for comfort and style. Each floor plan is thoughtfully crafted to suit your lifestyle. Browse our available apartment homes today and step into a new chapter of elevated living!",
  "property_gallery_blurb": "At The Nolan in Morrisville, PA, picture your life in spacious, beautifully designed one or two-bedroom apartments surrounded by park-like grounds. Enjoy modern amenities, pet-friendly policies, and convenient access to Route 1 and I-95. Explore our photo gallery and envision a vibrant lifestyle waiting for you!",
  "property_interactivemap_blurb": "Welcome to The Nolan in Morrisville, PA, where spacious one and two-bedroom apartments blend modern comfort with a serene, park-like setting. Enjoy pet-friendly amenities, beautifully landscaped grounds, and convenient access to Route 1 and I-95. Navigate your future home effortlessly with our interactive community map today!",
  "property_pets_blurb": "At The Nolan in Morrisville, PA, your furry friends are cherished companions. With no weight restrictions and a welcoming atmosphere, bring up to two pets to enjoy our vibrant community. For just $50 monthly for one pet or $75 for two, your pets will thrive in their new home!",
  "property_referafriend_blurb": "At The Nolan in Morrisville, PA, we celebrate community connections! With spacious one and two-bedroom floor plans, you’ll find the perfect space for you and your friends. Share the joy of living here—refer a friend today and let great friendships blossom in our vibrant neighborhood!",
  "property_residentaccess_blurb": "Welcome to The Nolan in Morrisville, PA, where comfort meets convenience. Whether you choose a cozy one-bedroom or a spacious two-bedroom layout, you'll find the perfect home that fits your lifestyle. Access your resident portal today to effortlessly manage rent payments, schedule maintenance, and enjoy all the amenities we offer!",
  "property_reviews_blurb": "Experience the charm of life at The Nolan, where residents revel in a peaceful atmosphere and responsive management. As one happy tenant shared, \"Kevin and Ken are awesome! They are literally a phone call away.\" Join a community that prioritizes your comfort and satisfaction, and see what our residents have to say!",
  "property_created_at": "1757012366473",
  "property_scheduletour_blurb": "At The Nolan in Morrisville, PA, find your perfect haven with our thoughtfully designed one and two-bedroom floor plans. Experience modern living with elegance and comfort. Ready to see why residents love calling The Nolan home? Schedule a tour today and uncover the charm that awaits you!",
  "property_thankyou_blurb": "Thank you for reaching out! At The Nolan in Morrisville, PA, we offer thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Our team will be in touch soon to help you find your perfect home in our welcoming community. Stay tuned for a response!",
  "property_virtualtours_blurb": "Step into a world of comfort at The Nolan in Morrisville, PA. Choose from thoughtfully designed one and two-bedroom floor plans that perfectly fit your lifestyle. Ready to envision your new home? Take a virtual tour and experience the vibrant community and inviting atmosphere waiting for you!",
  "property_copyright": "2025 All Rights Reserved. The Nolan",
  "property_seo_title_home": "The Nolan |  Apartments in Morrisville, PA",
  "property_seo_description_home": "Discover modern living at The Nolan in Morrisville, PA. Enjoy pet-friendly 1 & 2 bedroom apartments with stunning kitchens and scenic grounds!",
  "property_seo_title_floorplans": "Floor Plans | Morrisville, PA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at The Nolan in Morrisville, PA! Choose from stylish one and two-bedroom options. Browse our floor plans and envision your new home!",
  "property_seo_title_amenities": "Amenities | Morrisville, PA Apartments for Rent",
  "property_seo_description_amenities": "Experience life at The Nolan in Morrisville! Enjoy pet-friendly living, spacious floor plans, stunning grounds, and modern amenities just minutes from I-95.",
  "property_seo_title_gallery": "Gallery | Apartments in Morrisville, PA",
  "property_seo_description_gallery": "Picture your new life at The Nolan in Morrisville, PA! Spacious 1 & 2 bedroom homes, pet-friendly, with stunning grounds & modern amenities await you.",
  "property_seo_title_virtualtours": "Virtual Tours | The Nolan Apartments",
  "property_seo_description_virtualtours": "Step inside The Nolan in Morrisville, PA! Take a virtual tour of our stylish one and two-bedroom apartments, and envision your new home today!",
  "property_seo_title_interactivemap": "Interactive Map | The Nolan Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at The Nolan in Morrisville, PA! Choose from spacious floor plans, enjoy pet-friendly amenities, and navigate with our interactive map!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Morrisville, PA",
  "property_seo_description_neighborhood": "Uncover the vibrant lifestyle around The Nolan in Morrisville, PA. From local favorites to hidden gems, see what makes our neighborhood truly special!",
  "property_seo_title_contact": "Contact Us | The Nolan",
  "property_seo_description_contact": "Connect with The Nolan in Morrisville, PA! Whether you're eyeing a 1 or 2-bedroom apartment, our leasing team is here to help. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Morrisville, PA",
  "property_seo_description_faqs": "Unearth answers to your questions at The Nolan! From pet-friendly living to spacious floor plans, explore why our Morrisville community feels like home.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Morrisville, PA",
  "property_seo_description_reviews": "Discover life at The Nolan in Morrisville, PA! Read resident reviews and find your ideal 1 or 2-bedroom apartment with modern amenities.",
  "property_seo_title_applynow": "Apply Now | Apartments in Morrisville, PA",
  "property_seo_description_applynow": "Experience modern living at The Nolan in Morrisville, PA. Enjoy spacious 1 & 2-bedroom homes, pet-friendly perks, and convenient online services. Lease today!",
  "property_seo_title_residentaccess": "Resident Access | The Nolan",
  "property_seo_description_residentaccess": "Welcome to The Nolan! Log in to your resident portal for easy rent payments, hassle-free maintenance requests, and all your community updates in one place!",
  "property_seo_title_referafriend": "Refer A Friend | The Nolan",
  "property_seo_description_referafriend": "Refer a friend to The Nolan in Morrisville, PA! Share the joy of great living with neighbors who become family. Enjoy perks together today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Nolan",
  "property_seo_description_scheduletour": "Experience life at The Nolan in Morrisville, PA. Schedule a tour today and see why our vibrant community is the perfect place to call home!",
  "property_seo_title_privacy": "Privacy Policy | The Nolan",
  "property_seo_description_privacy": "Your privacy matters at The Nolan! Learn how we protect your information while you enjoy modern living in Morrisville, PA. Read our privacy policy now!",
  "property_seo_title_accessibility": "Website Accessibility | The Nolan",
  "property_seo_description_accessibility": "Experience seamless living at The Nolan in Morrisville, PA. Our accessibility statement ensures everyone feels at home. Join our inclusive community today!",
  "property_seo_title_sitemap": "Sitemap | The Nolan",
  "property_seo_description_sitemap": "Navigate your way to your dream home at The Nolan in Morrisville, PA. Check out our sitemap for easy access to all community features and updates!",
  "property_seo_title_thankyou": "Thank You | The Nolan",
  "property_seo_description_thankyou": "Thank you for reaching out to The Nolan! Our team will be in touch soon to help you discover your perfect Morrisville home—exciting living awaits!",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1791293643235",
  "amenities": [
    {
      "id": "custom_aebfa11e-44d0-465c-a451-424cdcb9bb69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_73bc1333-2588-4523-b3e4-e12a48d11079",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_841bd0a4-7ca6-4695-a66f-d156d452ecf3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment & Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7c6d71a6-7d1b-4f89-a306-0d8e661cbeac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_af3ff352-2d08-4699-a254-e202b7c431ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "external_id": "false",
      "title": "Storage Space Available",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d60c2244-3bec-4c45-a62b-fdb310184c71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "external_id": "false",
      "title": "6-Panel Doors*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2df23928-8843-4742-9c82-6b2c97648a74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "external_id": "false",
      "title": "Balcony or Patio",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4af57d44-e70c-4c91-9263-d6e07432acd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "external_id": "false",
      "title": "Cable-Ready",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2d8af16f-ae08-43a6-bb46-9a9c5c0592ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "external_id": "false",
      "title": "Central Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_164c97bf-38c3-4cf4-83fd-d03b2ee4f55e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0d830560-c115-4eb0-b6fa-d932b2882106",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "external_id": "false",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c7cda958-0285-4304-a97e-148be9bea121",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_32d1b136-457c-438f-8d64-57a11202f699",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Kitchens",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d98cbbc8-33c1-4b27-aaac-9e45fc86dcc3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless-Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5a8cb766-9ab6-4474-a1ed-8b3cf068a628",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "external_id": "false",
      "title": "Upgraded Bathroom Vanity",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f0e15178-f77f-412c-aede-f86acd3785cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl Wood-Style Flooring",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_492e5fcc-1d62-40c9-8d7e-f22980adf62a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "external_id": "false",
      "title": "Located in the Pennsbury School District",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_491da970-f488-4805-b77c-848fdc82301f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "external_id": "false",
      "title": "Minutes to Route 1 & I-95",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_56c5dd00-feda-477b-addf-68061bb144e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "external_id": "false",
      "title": "Park-Like Setting",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_04791f25-66b0-4ebf-975e-0157d6fbb072",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "external_id": "false",
      "title": "3 miles to SEPTA Yardley Station",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_e449f33d-4458-4aff-93b9-3d55ebf11206",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd931-0cb8-73d8-b804-2397443ba331.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel appliances, and gray wood-look flooring.",
        "public_id": "019fd931-0cb8-73d8-b804-2397443ba331",
        "storage_key": "property/6767906449166354/019fd931-0cb8-73d8-b804-2397443ba331.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright, modern apartment kitchen with stainless-steel appliances, granite countertops, and white cabinetry.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, granite countertops, stainless steel stove and refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8857ac2d/dms3rep/multi/opt/5767906449162442/6767906449166354/99842d5ac99fadb1d52b21db00132f6b-1920w.webp"
    },
    {
      "id": "custom_89cc8fd3-4cd1-452a-ab47-e102bcb570bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd931-0d15-73bc-af53-9943fc1f6d2f.webp",
      "image_media": {
        "alt_text": "A staged bedroom with a bed, dresser, and artwork.",
        "public_id": "019fd931-0d15-73bc-af53-9943fc1f6d2f",
        "storage_key": "property/6767906449166354/019fd931-0d15-73bc-af53-9943fc1f6d2f.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Bedroom in a modern apartment with a gray bed, yellow accent pillows, white dresser, and a tall plant.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8857ac2d/dms3rep/multi/opt/5767906449162442/6767906449166354/8e83b07f8946005cf985bb0929f87adf-1920w.jpg"
    },
    {
      "id": "custom_a0a78411-8204-43d2-a487-2a3a59b5351d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd931-0d7d-7563-aaad-0fdc4f67762a.webp",
      "image_media": {
        "alt_text": "Living room with sofa, armchair, coffee table, and TV.",
        "public_id": "019fd931-0d7d-7563-aaad-0fdc4f67762a",
        "storage_key": "property/6767906449166354/019fd931-0d7d-7563-aaad-0fdc4f67762a.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Living room in an apartment with a sliding glass door, sofa, armchair, rug, coffee table, TV, and a potted plant.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8857ac2d/dms3rep/multi/opt/5767906449162442/6767906449166354/59fe96d08b5c7f153b8d9d33bf88b5d6-1920w.jpg"
    },
    {
      "id": "custom_0f0f0400-8936-4eac-8f2f-19ecc6c78d97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd931-0d0a-757b-941e-d11d2649411a.webp",
      "image_media": {
        "alt_text": "Living room with a white couch, accent chair, coffee tables, and a TV.",
        "public_id": "019fd931-0d0a-757b-941e-d11d2649411a",
        "storage_key": "property/6767906449166354/019fd931-0d0a-757b-941e-d11d2649411a.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Modern furnished living room in a contemporary apartment with wood floors, plants, and a sliding door to a balcony.",
      "link": "false",
      "alt_text": "Bright living room in an apartment with a white sofa, armchair, coffee tables, plants, and sliding balcony door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8857ac2d/dms3rep/multi/opt/5767906449162442/6767906449166354/6a04acf2ee28e5c08b52f59425ddc9e3-1920w.webp"
    },
    {
      "id": "custom_2fc56418-34dd-413d-9a87-2038f018eb90",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd931-1898-7648-8119-fb0cb1a1c51e.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel appliances, and a dining area.",
        "public_id": "019fd931-1898-7648-8119-fb0cb1a1c51e",
        "storage_key": "property/6767906449166354/019fd931-1898-7648-8119-fb0cb1a1c51e.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Modern apartment kitchen with white cabinets, stainless steel appliances, and a wooden dining table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8857ac2d/dms3rep/multi/opt/5767906449162442/6767906449166354/5198fca95de3fc1c836dfc1eec5fa17c-1920w.jpg"
    },
    {
      "id": "custom_df12d02d-d43c-449b-9f5e-89f1d8e73533",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd931-195c-7643-8336-23412c38e5c1.webp",
      "image_media": {
        "alt_text": "Bedroom with a closet and an adjoining bathroom visible through an open door.",
        "public_id": "019fd931-195c-7643-8336-23412c38e5c1",
        "storage_key": "property/6767906449166354/019fd931-195c-7643-8336-23412c38e5c1.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Neutral-toned bedroom with a built-in closet, laminate flooring, and a window with blinds.",
      "link": "false",
      "alt_text": "Bedroom with white closet doors, laminate flooring, and a window with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8857ac2d/dms3rep/multi/opt/5767906449162442/6767906449166354/3c35c25a4f51900a2baeb6283518f991-1920w.jpg"
    },
    {
      "id": "custom_0045cbfc-763e-4538-962d-98b17761f7e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd931-1949-74b7-b678-76ba7866696a.webp",
      "image_media": {
        "alt_text": "Empty bedroom with closet and doors",
        "public_id": "019fd931-1949-74b7-b678-76ba7866696a",
        "storage_key": "property/6767906449166354/019fd931-1949-74b7-b678-76ba7866696a.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious empty apartment living area with neutral gray walls, wood-like flooring, and built-in closet.",
      "link": "false",
      "alt_text": "Empty living area with gray walls, white trim, wood-look flooring, and a closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8857ac2d/dms3rep/multi/opt/5767906449162442/6767906449166354/a0f26840c857cf69914100bbc94cbb54-1920w.jpg"
    },
    {
      "id": "custom_5f0ec514-4319-4df5-92c5-1a1be6a5a485",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd931-1977-72ff-a3d8-1013accd6d8a.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with white countertop, sink, and chrome faucet, with a mirror and three lights above.",
        "public_id": "019fd931-1977-72ff-a3d8-1013accd6d8a",
        "storage_key": "property/6767906449166354/019fd931-1977-72ff-a3d8-1013accd6d8a.webp",
        "width": 1920,
        "height": 2876
      },
      "title": "Apartment",
      "description": "Bright, clean apartment bathroom with a white vanity, sink, and a three-light fixture above.",
      "link": "false",
      "alt_text": "White bathroom vanity with sink, cabinet doors, and a rectangular mirror above.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8857ac2d/dms3rep/multi/opt/5767906449162442/6767906449166354/f1f8ffb83c2b59c1e6562a0ab58d2742-1920w.webp"
    },
    {
      "id": "custom_31efc733-c00d-4d37-ac16-8a6433032942",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd931-236b-7429-8eba-de2ea0331e7d.webp",
      "image_media": {
        "alt_text": "White Amana washer and dryer in a laundry closet with louvered doors.",
        "public_id": "019fd931-236b-7429-8eba-de2ea0331e7d",
        "storage_key": "property/6767906449166354/019fd931-236b-7429-8eba-de2ea0331e7d.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "In-unit laundry closet with a white washer and dryer for convenient resident use.",
      "link": "false",
      "alt_text": "Laundry closet with a white top-load washer and white front-load dryer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8857ac2d/dms3rep/multi/opt/5767906449162442/6767906449166354/d3e2b283ee277299880eec7602442a51-1920w.webp"
    },
    {
      "id": "custom_f58e29cf-9eb9-46cb-8011-891b3510d1da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd931-259a-741b-aceb-281a7f26a1de.webp",
      "image_media": {
        "alt_text": "Exterior of a brick building with manicured landscaping and a green lawn.",
        "public_id": "019fd931-259a-741b-aceb-281a7f26a1de",
        "storage_key": "property/6767906449166354/019fd931-259a-741b-aceb-281a7f26a1de.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Exterior shot of a multifamily building showing white brick foundation, brown shingled upper exterior, and well-maintained landscaping.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with white brick base, brown shingled upper facade, and landscaped lawn",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8857ac2d/dms3rep/multi/opt/5767906449162442/6767906449166354/40c864c3475e2f52114821fb486f7582-1920w.jpg"
    },
    {
      "id": "custom_2c7d7a25-a141-4923-abd5-bb6e5d5db00f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd931-25d0-76db-80c7-390e131e7aa9.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and mature trees.",
        "public_id": "019fd931-25d0-76db-80c7-390e131e7aa9",
        "storage_key": "property/6767906449166354/019fd931-25d0-76db-80c7-390e131e7aa9.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Exterior view of a two-story apartment building with blue doors and a grassy, tree-filled courtyard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8857ac2d/dms3rep/multi/opt/5767906449162442/6767906449166354/a94b14e5c2f97aff7ef95147e3bc242e-1920w.jpg"
    },
    {
      "id": "custom_9759c999-433c-41f4-8ba5-370fb4a770a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd931-2882-766a-88d6-8e5b34fd3fe8.webp",
      "image_media": {
        "alt_text": "Exterior view of apartments with manicured lawns and walkways.",
        "public_id": "019fd931-2882-766a-88d6-8e5b34fd3fe8",
        "storage_key": "property/6767906449166354/019fd931-2882-766a-88d6-8e5b34fd3fe8.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with a green lawn and winding sidewalk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8857ac2d/dms3rep/multi/opt/5767906449162442/6767906449166354/98004090833cae98d525ec107f7e4c97-1920w.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_fe160a03-bae2-4c77-871c-8b1dfdcac224",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Dunkin'",
      "poi_type": "Restaurants",
      "poi_address": "2 W Bridge St, Morrisville, PA 19067, USA",
      "poi_short_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_long_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-9bbd-7624-9335-5389007d4299.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-9bbd-7624-9335-5389007d4299",
        "storage_key": "property/6767906449166354/019fd92f-9bbd-7624-9335-5389007d4299.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.dunkindonuts.com/en/pa/morrisville/2-w-bridge-st/348479?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=348479&y_source=1_MTIxMDc0MzAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16171126459426067335&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dunkin",
      "poi_latitude": "40.208238",
      "poi_longitude": "-74.776038",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 215-337-8181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd34-70d7-b6af-7c5d4237aa0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd34-70d7-b6af-7c5d4237aa0d",
        "storage_key": "property/6767906449166354/019d026c-fd34-70d7-b6af-7c5d4237aa0d.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJlypTpOBZwYkRh9MCKNZha-A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ea33b9d0-b73c-46e5-85a5-c88853179425",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "nabeautybar",
      "poi_type": "Restaurants",
      "poi_address": "229 Plaza Blvd #26, Morrisville, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-8cfc-763f-a495-a65c25a5e6e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-8cfc-763f-a495-a65c25a5e6e8",
        "storage_key": "property/6767906449166354/019fd92f-8cfc-763f-a495-a65c25a5e6e8.webp",
        "width": 1280,
        "height": 890
      },
      "poi_business_url": "http://www.nabeautybar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15727746699966112938&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nabeautybar",
      "poi_latitude": "40.2063586",
      "poi_longitude": "-74.8012227",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 267-223-5458",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd31-7551-9eab-7bed21bd7cfd",
        "storage_key": "property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ70UAJXFXwYkRqmTNYEsuRNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1d7ffa27-923e-45ea-a338-8e38bbfb1842",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Edgewood Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1730 Yardley Langhorne Rd, Yardley, PA 19067, USA",
      "poi_short_description": "Casual cafe for breakfast and lunch with coffee, sandwiches, and other comfort food, plus kids' options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-9e22-718a-999b-3ac38acbf5c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-9e22-718a-999b-3ac38acbf5c7",
        "storage_key": "property/6767906449166354/019fd92f-9e22-718a-999b-3ac38acbf5c7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.edgewoodcafeyardley.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8838561338389520744&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edgewood-cafe",
      "poi_latitude": "40.2222053",
      "poi_longitude": "-74.8760774",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-321-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd34-70d7-b6af-7c5d4237aa0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd34-70d7-b6af-7c5d4237aa0d",
        "storage_key": "property/6767906449166354/019d026c-fd34-70d7-b6af-7c5d4237aa0d.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ0aCLspFTwYkRaGE1ZLXgqHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d07e32bd-2bd2-4e83-867d-8b2b5f1d7bf2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Villa Rosa Pizza & Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "661 Heacock Rd, Yardley, PA 19067, USA",
      "poi_short_description": "Family-friendly joint offering simple pizzas, subs & typical Italian dishes such as chicken piccata.",
      "poi_long_description": "Family-friendly joint offering simple pizzas, subs & typical Italian dishes such as chicken piccata.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-8e0b-743d-8161-2b9de1031db9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-8e0b-743d-8161-2b9de1031db9",
        "storage_key": "property/6767906449166354/019fd92f-8e0b-743d-8161-2b9de1031db9.webp",
        "width": 997,
        "height": 1280
      },
      "poi_business_url": "https://villarosapa.com/?y_source=1_OTY5Nzk1ODctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=15006913828293334892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "villa-rosa-pizza--restaurant",
      "poi_latitude": "40.2214985",
      "poi_longitude": "-74.87170689999999",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-321-0850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd3d-7659-87ab-ad96dca25ec4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd3d-7659-87ab-ad96dca25ec4",
        "storage_key": "property/6767906449166354/019d026c-fd3d-7659-87ab-ad96dca25ec4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6XZPeJ9WwYkRbFdS5p1EQ9A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0fad5c4e-5904-41b8-8f8d-fa5cc5ed274f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Ginger Wok Japanese & Chinese restaurant",
      "poi_type": "Restaurants",
      "poi_address": "677 Heacock Rd, Morrisville, PA 19067, USA",
      "poi_short_description": "Casual venue dishing up Chinese fare, plus Japanese bites like sushi.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-a7e1-7021-bbc7-23b4d9c3402e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-a7e1-7021-bbc7-23b4d9c3402e",
        "storage_key": "property/6767906449166354/019fd92f-a7e1-7021-bbc7-23b4d9c3402e.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://gingerwokrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2076339718773754780&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ginger-wok-japanese--chinese-restaurant",
      "poi_latitude": "40.2216525",
      "poi_longitude": "-74.8717363",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-493-1818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd3d-7659-87ab-ad96dca25ec4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd3d-7659-87ab-ad96dca25ec4",
        "storage_key": "property/6767906449166354/019d026c-fd3d-7659-87ab-ad96dca25ec4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJta7php9WwYkRnEuLKvmj0Bw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1c8b1d66-fbbf-4a77-9ba6-917e8940ec10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Venezia Pizza",
      "poi_type": "Restaurants",
      "poi_address": "672 Stony Hill Rd, Yardley, PA 19067, USA",
      "poi_short_description": "Murals depicting Venice adorn the walls at this laid-back spot serving pizza, pasta & subs.",
      "poi_long_description": "Murals depicting Venice adorn the walls at this laid-back spot serving pizza, pasta & subs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-9f32-778e-ab41-feee5c02532b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-9f32-778e-ab41-feee5c02532b",
        "storage_key": "property/6767906449166354/019fd92f-9f32-778e-ab41-feee5c02532b.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "http://veneziapizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3311644212404117709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "venezia-pizza",
      "poi_latitude": "40.2210558",
      "poi_longitude": "-74.8730104",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-321-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd3d-7659-87ab-ad96dca25ec4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd3d-7659-87ab-ad96dca25ec4",
        "storage_key": "property/6767906449166354/019d026c-fd3d-7659-87ab-ad96dca25ec4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoWoLlLxWwYkRzWDTht1S9S0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_02dc7fc9-4c2f-4092-8a78-cf7c4f5f7879",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Vault Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "10 S Main St, Yardley, PA 19067, USA",
      "poi_short_description": "Hip, speakeasy-style bar keeps its brewery in plain view & serves up craft beer, tapas & jazz.",
      "poi_long_description": "Hip, speakeasy-style bar keeps its brewery in plain view & serves up craft beer, tapas & jazz.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-b827-760f-a5ee-c5c1a05e00fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-b827-760f-a5ee-c5c1a05e00fa",
        "storage_key": "property/6767906449166354/019fd92f-b827-760f-a5ee-c5c1a05e00fa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.vaultbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17066349880954389446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vault-brewing-company",
      "poi_latitude": "40.24234510000001",
      "poi_longitude": "-74.8385061",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 267-573-4291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd3d-7659-87ab-b047cac18f21.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd3d-7659-87ab-b047cac18f21",
        "storage_key": "property/6767906449166354/019d026c-fd3d-7659-87ab-b047cac18f21.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdw12rFBWwYkRxgPRmsva1-w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5e7399b9-6538-4229-93c3-673d40dd024d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Trattoria Rosa Bianca",
      "poi_type": "Restaurants",
      "poi_address": "94 S Main St, Yardley, PA 19067, USA",
      "poi_short_description": "Family-run Italian BYOB in a historic, quaint Victorian home with seasonal outdoor dining.",
      "poi_long_description": "Family-run Italian BYOB in a historic, quaint Victorian home with seasonal outdoor dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-aeb3-7729-a81f-b2b93948fe3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-aeb3-7729-a81f-b2b93948fe3f",
        "storage_key": "property/6767906449166354/019fd92f-aeb3-7729-a81f-b2b93948fe3f.webp",
        "width": 1280,
        "height": 847
      },
      "poi_business_url": "http://www.rosabiancatrattoria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17846507667440596570&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trattoria-rosa-bianca",
      "poi_latitude": "40.240431",
      "poi_longitude": "-74.835751",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 267-392-5738",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd3d-7659-87ab-ad96dca25ec4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd3d-7659-87ab-ad96dca25ec4",
        "storage_key": "property/6767906449166354/019d026c-fd3d-7659-87ab-ad96dca25ec4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW5pR4FZWwYkRWvYULyuIq_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7473bcfa-0071-468d-ad9b-105f2681a7a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Charcoal BYOB",
      "poi_type": "Restaurants",
      "poi_address": "11 S Delaware Ave, Yardley, PA 19067, USA",
      "poi_short_description": "Creative, market-driven fare & river views are hallmarks of this down-to-earth American cafe.",
      "poi_long_description": "Creative, market-driven fare & river views are hallmarks of this down-to-earth American cafe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-b5ca-723b-84ad-91cdc7077fb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-b5ca-723b-84ad-91cdc7077fb0",
        "storage_key": "property/6767906449166354/019fd92f-b5ca-723b-84ad-91cdc7077fb0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.charcoalbyob.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17856138644412811607&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charcoal-byob",
      "poi_latitude": "40.2445056",
      "poi_longitude": "-74.8356222",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-493-6394",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd3d-7659-87ab-ad96dca25ec4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd3d-7659-87ab-ad96dca25ec4",
        "storage_key": "property/6767906449166354/019d026c-fd3d-7659-87ab-ad96dca25ec4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbeOupVFWwYkRV8lZwH2_zfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7971e45d-ac03-4a50-8ac6-16813b8ca58a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Canal Street Grille",
      "poi_type": "Restaurants",
      "poi_address": "27 E Afton Ave, Yardley, PA 19067, USA",
      "poi_short_description": "Cozy eatery on the Delaware Canal offers casual fine dining, American & Greek fare, & outdoor seats.",
      "poi_long_description": "Cozy eatery on the Delaware Canal offers casual fine dining, American & Greek fare, & outdoor seats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-c061-7338-af18-cc9457e92066.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-c061-7338-af18-cc9457e92066",
        "storage_key": "property/6767906449166354/019fd92f-c061-7338-af18-cc9457e92066.webp",
        "width": 1080,
        "height": 609
      },
      "poi_business_url": "http://www.canalstreetyardley.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3752483597424969073&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "canal-street-grille",
      "poi_latitude": "40.2430409",
      "poi_longitude": "-74.8379333",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-321-1333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd3d-7659-87ab-ad96dca25ec4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd3d-7659-87ab-ad96dca25ec4",
        "storage_key": "property/6767906449166354/019d026c-fd3d-7659-87ab-ad96dca25ec4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX4nEvVBWwYkRccX-SfN_EzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b14ec086-83a7-4234-a361-6c8b084def32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Pretty Bird Coffee Roasters",
      "poi_type": "Restaurants",
      "poi_address": "7 S Main St, Yardley, PA 19067, USA",
      "poi_short_description": "Compact eatery serving coffee, biscuits, donuts and breakfast staples.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-c2c6-71bf-8933-60a71e1ec276.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-c2c6-71bf-8933-60a71e1ec276",
        "storage_key": "property/6767906449166354/019fd92f-c2c6-71bf-8933-60a71e1ec276.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://prettybirdcoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1114700166355124276&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pretty-bird-coffee-roasters",
      "poi_latitude": "40.2422501",
      "poi_longitude": "-74.83898049999999",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 267-714-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd34-70d7-b6af-7c5d4237aa0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd34-70d7-b6af-7c5d4237aa0d",
        "storage_key": "property/6767906449166354/019d026c-fd34-70d7-b6af-7c5d4237aa0d.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJa3t7qlBWwYkRNICqNuU1eA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_668abf3a-7c3d-4b49-b8fa-5b18d70782d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Continental Tavern",
      "poi_type": "Restaurants",
      "poi_address": "2 N Main St, Yardley, PA 19067, USA",
      "poi_short_description": "Daily drink & food specials include pasta, steak & draft beers at this chill bar with patio seating.",
      "poi_long_description": "Daily drink & food specials include pasta, steak & draft beers at this chill bar with patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-c7be-70b9-8a38-0c5a06f2694a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-c7be-70b9-8a38-0c5a06f2694a",
        "storage_key": "property/6767906449166354/019fd92f-c7be-70b9-8a38-0c5a06f2694a.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://contav.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3113489717465369406&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "continental-tavern",
      "poi_latitude": "40.2426618",
      "poi_longitude": "-74.8389705",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 215-493-9191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd3d-7659-87ab-ad96dca25ec4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd3d-7659-87ab-ad96dca25ec4",
        "storage_key": "property/6767906449166354/019d026c-fd3d-7659-87ab-ad96dca25ec4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy9jQqVBWwYkRPsta7WZWNSs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_606bbc3c-76c2-44ad-9114-7a5a437200ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Panna Gelateria And Bakery",
      "poi_type": "Restaurants",
      "poi_address": "25 S Main St, Yardley, PA 19067, USA",
      "poi_short_description": "Charming, family-run dessert spot dishing up homemade gelato and rich hot chocolate in a fun atmosphere.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-ce94-701f-9f19-e1f3f02ba24e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-ce94-701f-9f19-e1f3f02ba24e",
        "storage_key": "property/6767906449166354/019fd92f-ce94-701f-9f19-e1f3f02ba24e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pannagelateria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3630517419511484227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panna-gelateria-and-bakery",
      "poi_latitude": "40.2411948",
      "poi_longitude": "-74.83912769999999",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 215-369-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd3d-7659-87ab-ad96dca25ec4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd3d-7659-87ab-ad96dca25ec4",
        "storage_key": "property/6767906449166354/019d026c-fd3d-7659-87ab-ad96dca25ec4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEW2UwbNXwYkRQ4_ZlFswYjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_13bf063a-1d2a-4c57-a097-270f9c929361",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Yardley Ice House",
      "poi_type": "Restaurants",
      "poi_address": "77 S Main St, Yardley, PA 19067, USA",
      "poi_short_description": "Unassuming counter-serve providing classic & unique flavors of water ice & soft serve ice cream.",
      "poi_long_description": "Unassuming counter-serve providing classic & unique flavors of water ice & soft serve ice cream.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-d59a-756d-81be-aa69975c2958.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-d59a-756d-81be-aa69975c2958",
        "storage_key": "property/6767906449166354/019fd92f-d59a-756d-81be-aa69975c2958.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.yardleyicehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8465226981445573955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yardley-ice-house",
      "poi_latitude": "40.2403945",
      "poi_longitude": "-74.837105",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-321-9788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd3d-7659-87ab-ad96dca25ec4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd3d-7659-87ab-ad96dca25ec4",
        "storage_key": "property/6767906449166354/019d026c-fd3d-7659-87ab-ad96dca25ec4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK7qYIVdWwYkRQ50dxBaHenU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ca6e0318-40d1-4f0b-b90b-ed4777f709da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "590 W Trenton Ave, Morrisville, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-eeff-71ce-8525-5381c430d54d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-eeff-71ce-8525-5381c430d54d",
        "storage_key": "property/6767906449166354/019fd92f-eeff-71ce-8525-5381c430d54d.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/morrisville-pa-pharmacies/590-w-trenton-ave-morrisville-pa-19067/storeid=2568?WT.mc_id=LS_GOOGLE_RX_2568",
      "poi_directions_map_url": "https://maps.google.com/?cid=11413314006546361659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.2083851",
      "poi_longitude": "-74.8021413",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 215-736-9003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-0088-75ee-986d-e6c06f8ef9bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-0088-75ee-986d-e6c06f8ef9bf",
        "storage_key": "property/6767906449166354/019d026d-0088-75ee-986d-e6c06f8ef9bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs7ThwUBXwYkRO60vXp48ZJ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_31ab9d12-52f9-486b-888e-b014205796aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Burns Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "82 N Pennsylvania Ave, Morrisville, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.burnspharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12022500508389555751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burns-pharmacy",
      "poi_latitude": "40.2099924",
      "poi_longitude": "-74.776421",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 215-295-5585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-0088-75ee-986d-e6c06f8ef9bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-0088-75ee-986d-e6c06f8ef9bf",
        "storage_key": "property/6767906449166354/019d026d-0088-75ee-986d-e6c06f8ef9bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKzmlON5ZwYkRJz6DsoOA2KY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_355c34b4-bd1e-4eeb-83f9-a82c1df51653",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Wawa",
      "poi_type": "Shopping & Retail",
      "poi_address": "545 W Trenton Ave, Morrisville, PA 19067, USA",
      "poi_short_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_long_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-cfd6-732d-a230-da3c846df852.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-cfd6-732d-a230-da3c846df852",
        "storage_key": "property/6767906449166354/019fd92f-cfd6-732d-a230-da3c846df852.webp",
        "width": 500,
        "height": 400
      },
      "poi_business_url": "https://www.wawa.com/locations/8076?utm_source=gmblisting&utm_medium=organic&utm_campaign=locallisting",
      "poi_directions_map_url": "https://maps.google.com/?cid=16711504373858685747&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wawa",
      "poi_latitude": "40.206387",
      "poi_longitude": "-74.80396",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 267-768-8611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd3d-7659-87ab-ad96dca25ec4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd3d-7659-87ab-ad96dca25ec4",
        "storage_key": "property/6767906449166354/019d026c-fd3d-7659-87ab-ad96dca25ec4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm-vYEgtXwYkRM9M7yq8w6-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c7f3ed47-f419-40fe-be57-69c4bb371ca9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "303 W Trenton Ave, Morrisville, PA 19067, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-df08-7223-a0c3-51689d25af19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-df08-7223-a0c3-51689d25af19",
        "storage_key": "property/6767906449166354/019fd92f-df08-7223-a0c3-51689d25af19.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.7-eleven.com/locations/pa/morrisville/303-w-trenton-av-11365?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3757805408344223221&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "40.211339",
      "poi_longitude": "-74.79296599999999",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 215-295-4263",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-0080-76a0-ad94-1323887b55f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-0080-76a0-ad94-1323887b55f4",
        "storage_key": "property/6767906449166354/019d026d-0080-76a0-ad94-1323887b55f4.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJa_ZFUWZXwYkR9S1m8xtoJjQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_33f0fd66-2fe2-43ab-b685-91f36dd9f61c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "1279 Old Bristol Pike, Morrisville, PA 19067, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-dea3-7758-9934-04f118dd4071.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-dea3-7758-9934-04f118dd4071",
        "storage_key": "property/6767906449166354/019fd92f-dea3-7758-9934-04f118dd4071.webp",
        "width": 1280,
        "height": 537
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/pa/morrisville/17970",
      "poi_directions_map_url": "https://maps.google.com/?cid=6872651915548373549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "40.1731838",
      "poi_longitude": "-74.7918942",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 267-797-7956",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-0081-729b-9336-0f887b6e1b0b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-0081-729b-9336-0f887b6e1b0b",
        "storage_key": "property/6767906449166354/019d026d-0081-729b-9336-0f887b6e1b0b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJeTCn86RQwYkRLTIrG4GQYF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b2c39d08-6064-4ccb-90b5-44a212418741",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Friendly Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "1180 Bristol Pike, Morrisville, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-efeb-72bf-8137-a4204c0692c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-efeb-72bf-8137-a4204c0692c3",
        "storage_key": "property/6767906449166354/019fd92f-efeb-72bf-8137-a4204c0692c3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=34557823919710096&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "friendly-mart",
      "poi_latitude": "40.175824",
      "poi_longitude": "-74.7915076",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 215-295-5154",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-0080-76a0-ad94-1323887b55f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-0080-76a0-ad94-1323887b55f4",
        "storage_key": "property/6767906449166354/019d026d-0080-76a0-ad94-1323887b55f4.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJh1nWy7RMwYkRkN_xYijGegA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3f61a71f-e78b-4238-9bfb-d8cbbe552a2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Country Farm (Convenience Store)",
      "poi_type": "Shopping & Retail",
      "poi_address": "91 Makefield Rd, Morrisville, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-e770-7228-a238-c2c3de5f9f1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-e770-7228-a238-c2c3de5f9f1e",
        "storage_key": "property/6767906449166354/019fd92f-e770-7228-a238-c2c3de5f9f1e.webp",
        "width": 1265,
        "height": 949
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3830827152921265393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "country-farm-convenience-store",
      "poi_latitude": "40.2013402",
      "poi_longitude": "-74.82097689999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-295-9114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-0080-76a0-ad94-1323887b55f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-0080-76a0-ad94-1323887b55f4",
        "storage_key": "property/6767906449166354/019d026d-0080-76a0-ad94-1323887b55f4.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJd0fdrS5XwYkR8QTLvf_UKTU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7ef58f75-fd7a-4b89-a7fa-dc7e9340d7ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Pennsbury Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "227 Plaza Blvd, Morrisville, PA 19067, USA",
      "poi_short_description": "Shopping center with a mix of eateries and other businesses, including a laundromat and a watch store.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-f179-751a-bfc0-404567f22d16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-f179-751a-bfc0-404567f22d16",
        "storage_key": "property/6767906449166354/019fd92f-f179-751a-bfc0-404567f22d16.webp",
        "width": 1280,
        "height": 607
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8644713203225823496&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pennsbury-plaza",
      "poi_latitude": "40.2060432",
      "poi_longitude": "-74.8023834",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 215-240-1858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-0081-729b-9336-0f887b6e1b0b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-0081-729b-9336-0f887b6e1b0b",
        "storage_key": "property/6767906449166354/019d026d-0081-729b-9336-0f887b6e1b0b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJk5iKMUdXwYkRCIlnT9sw-Hc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_93d9531c-625d-47a0-82bc-cd9c5178ca7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Oxford Valley Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "2300 E Lincoln Hwy, Langhorne, PA 19047, USA",
      "poi_short_description": "2-story mall since 1973, with department stores, a food court, kids' play area & nursing lounge.",
      "poi_long_description": "2-story mall since 1973, with department stores, a food court, kids' play area & nursing lounge.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-fc01-737b-a65d-1a37f058227d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-fc01-737b-a65d-1a37f058227d",
        "storage_key": "property/6767906449166354/019fd92f-fc01-737b-a65d-1a37f058227d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/oxford-valley-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=14706460198924046559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oxford-valley-mall",
      "poi_latitude": "40.18381590000001",
      "poi_longitude": "-74.88062409999999",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 215-752-0221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-0081-729b-9336-0f887b6e1b0b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-0081-729b-9336-0f887b6e1b0b",
        "storage_key": "property/6767906449166354/019d026d-0081-729b-9336-0f887b6e1b0b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJoz3RSOdTwYkR39BJ_KHXF8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_10564f11-7350-4c83-beb4-ecdd5bd22d1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Eleanor Roosevelt Elementary School",
      "poi_type": "Education",
      "poi_address": "185 Walton Dr, Morrisville, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://er.pennsburysd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4647159238792436062&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eleanor-roosevelt-elementary-school",
      "poi_latitude": "40.2006529",
      "poi_longitude": "-74.82654",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 215-428-4256",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-009b-744a-bc03-5b3618299d47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-009b-744a-bc03-5b3618299d47",
        "storage_key": "property/6767906449166354/019d026d-009b-744a-bc03-5b3618299d47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS_mJ-NVWwYkRXtnlurQGfkA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d844b93b-1bd4-41fb-af7d-4ff6161941b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Makefield Elementary School",
      "poi_type": "Education",
      "poi_address": "1939 Makefield Rd, Yardley, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://mk.pennsburysd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12795688520604978086&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "makefield-elementary-school",
      "poi_latitude": "40.2228816",
      "poi_longitude": "-74.8201924",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-321-2420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-009b-744a-bc03-5b3618299d47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-009b-744a-bc03-5b3618299d47",
        "storage_key": "property/6767906449166354/019d026d-009b-744a-bc03-5b3618299d47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG3WbDhtXwYkRpgs0P-pqk7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_af4b8b5d-070b-42a9-aa5a-0968c72d6240",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "William Penn Middle School",
      "poi_type": "Education",
      "poi_address": "1524 Derbyshire Rd, Yardley, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://wp.pennsburysd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3789863644294487878&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-penn-middle-school",
      "poi_latitude": "40.2112969",
      "poi_longitude": "-74.8300502",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-428-4280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-009b-744a-bc03-5b3618299d47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-009b-744a-bc03-5b3618299d47",
        "storage_key": "property/6767906449166354/019d026d-009b-744a-bc03-5b3618299d47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcxA3EdlWwYkRRh9XqedMmDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5ff1c5a7-cb82-4c3b-9217-146ee7064abc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Pennsbury West High School",
      "poi_type": "Education",
      "poi_address": "608 S Olds Blvd, Fairless Hills, PA 19030, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://phs.pennsburysd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3690661023909728199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pennsbury-west-high-school",
      "poi_latitude": "40.1773133",
      "poi_longitude": "-74.8426109",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 215-949-6780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-009b-744a-bc03-5b3618299d47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-009b-744a-bc03-5b3618299d47",
        "storage_key": "property/6767906449166354/019d026d-009b-744a-bc03-5b3618299d47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnUiE2BdRwYkRx8-EtKXcNzM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bc80f443-bcae-4719-994f-d7642838d4a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Valley Day School",
      "poi_type": "Education",
      "poi_address": "300 Allendale Dr, Morrisville, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-f7c8-7683-b23e-9cd6fe533301.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-f7c8-7683-b23e-9cd6fe533301",
        "storage_key": "property/6767906449166354/019fd92f-f7c8-7683-b23e-9cd6fe533301.webp",
        "width": 467,
        "height": 470
      },
      "poi_business_url": "http://www.valleyday.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1229559251518122641&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-day-school",
      "poi_latitude": "40.2030235",
      "poi_longitude": "-74.8123231",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 215-295-1155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-009b-744a-bc03-5b3618299d47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-009b-744a-bc03-5b3618299d47",
        "storage_key": "property/6767906449166354/019d026d-009b-744a-bc03-5b3618299d47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY1-8ejBXwYkRkWoI8Z9FEBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fc5971e6-d9ca-4dae-8045-348f79a5e55e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "The Montessori School",
      "poi_type": "Education",
      "poi_address": "501 W Maple Ave, Morrisville, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-fb06-763c-83e7-4a44f02fb297.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-fb06-763c-83e7-4a44f02fb297",
        "storage_key": "property/6767906449166354/019fd92f-fb06-763c-83e7-4a44f02fb297.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "http://tms-montessori.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7609757661283748990&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-montessori-school",
      "poi_latitude": "40.2110665",
      "poi_longitude": "-74.7895357",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 215-295-1170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-009b-744a-bc03-5b3618299d47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-009b-744a-bc03-5b3618299d47",
        "storage_key": "property/6767906449166354/019d026d-009b-744a-bc03-5b3618299d47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiztcp2dXwYkRfgygU0ZKm2k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_10d69999-66f7-45f1-9523-61e9f6b69e78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Abrams Hebrew Academy",
      "poi_type": "Education",
      "poi_address": "31 W College Ave, Yardley, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-fb0b-7375-a03b-c91f909cb6ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-fb0b-7375-a03b-c91f909cb6ac",
        "storage_key": "property/6767906449166354/019fd92f-fb0b-7375-a03b-c91f909cb6ac.webp",
        "width": 960,
        "height": 716
      },
      "poi_business_url": "http://abramsonline.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12999711092305875473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abrams-hebrew-academy",
      "poi_latitude": "40.238386",
      "poi_longitude": "-74.8376454",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-493-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-009b-744a-bc03-5b3618299d47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-009b-744a-bc03-5b3618299d47",
        "storage_key": "property/6767906449166354/019d026d-009b-744a-bc03-5b3618299d47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3aBLkFdWwYkREdKY71xAaLQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_393d4967-7e58-46f3-888d-df21574d2742",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Bucks County Community College Gene and Marlene Epstein Campus at Lower Bucks",
      "poi_type": "Education",
      "poi_address": "1304 Veterans Hwy, Bristol, PA 19007, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-1418-739d-9e70-a9253a3dffdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-1418-739d-9e70-a9253a3dffdb",
        "storage_key": "property/6767906449166354/019fd930-1418-739d-9e70-a9253a3dffdb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.bucks.edu/campus/lbc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1329569734629254331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bucks-county-community-college-gene-and-marlene-epstein-campus-at-lower-bucks",
      "poi_latitude": "40.1127606",
      "poi_longitude": "-74.876588",
      "poi_miles_from_property": "12.0 mi",
      "poi_walking_minutes": "4 hours 24 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 267-685-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-009b-744a-bc03-5b3618299d47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-009b-744a-bc03-5b3618299d47",
        "storage_key": "property/6767906449166354/019d026d-009b-744a-bc03-5b3618299d47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI_Mqp-NNwYkRu-SvGKGUcxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_915732d7-a528-4095-8e53-69e859520b4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Morrisville Tavern",
      "poi_type": "Entertainment",
      "poi_address": "376 W Trenton Ave, Morrisville, PA 19067, USA",
      "poi_short_description": "Longtime neighborhood bar and restaurant featuring regular live music, karaoke, trivia nights, and pool tables.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-0fce-775f-8f1f-1d33a9cf54c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-0fce-775f-8f1f-1d33a9cf54c4",
        "storage_key": "property/6767906449166354/019fd930-0fce-775f-8f1f-1d33a9cf54c4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.morrisvilletavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1353312234401026261&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morrisville-tavern",
      "poi_latitude": "40.209849",
      "poi_longitude": "-74.798687",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 215-295-5310",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd3d-7659-87ab-b047cac18f21.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd3d-7659-87ab-b047cac18f21",
        "storage_key": "property/6767906449166354/019d026c-fd3d-7659-87ab-b047cac18f21.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB7XrJEJXwYkR1dCpmU7uxxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3b52afc9-d708-4c96-ad6c-93cd67ebc0e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Snipes Farm and Education Center",
      "poi_type": "Entertainment",
      "poi_address": "890 W Bridge St, Morrisville, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-079e-7178-84af-92e975755652.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-079e-7178-84af-92e975755652",
        "storage_key": "property/6767906449166354/019fd930-079e-7178-84af-92e975755652.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://snipesfarm.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10297417065508989600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "snipes-farm-and-education-center",
      "poi_latitude": "40.1978969",
      "poi_longitude": "-74.79691620000001",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-295-1139",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd31-7551-9eab-7bed21bd7cfd",
        "storage_key": "property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ75Fq009XwYkRoGq1VUPG544",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f2402750-f1b2-4196-94f1-2e42ddfc62b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "New Hope Railroad",
      "poi_type": "Entertainment",
      "poi_address": "32 W Bridge St, New Hope, PA 18938, USA",
      "poi_short_description": "This heritage railroad operates both steam & diesel locomotives along its 18 mile route.",
      "poi_long_description": "This heritage railroad operates both steam & diesel locomotives along its 18 mile route.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-050e-764c-9784-c7a961e4f4d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-050e-764c-9784-c7a961e4f4d9",
        "storage_key": "property/6767906449166354/019fd930-050e-764c-9784-c7a961e4f4d9.webp",
        "width": 1022,
        "height": 684
      },
      "poi_business_url": "https://www.newhoperailroad.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18369834461023669595&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-hope-railroad",
      "poi_latitude": "40.3643004",
      "poi_longitude": "-74.9531034",
      "poi_miles_from_property": "15.6 mi",
      "poi_walking_minutes": "5 hours 39 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 215-862-2332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd31-7551-9eab-7bed21bd7cfd",
        "storage_key": "property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXUQdHU__w4kRW40LYB3D7v4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c4eeb2c5-8042-4806-83e5-bcb699e2e320",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "The Bucks County Children's Museum - Advance Ticketing Recommended",
      "poi_type": "Entertainment",
      "poi_address": "500 Union Square Dr, New Hope, PA 18938, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-0e81-70d8-8bc5-80d471b09d4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-0e81-70d8-8bc5-80d471b09d4c",
        "storage_key": "property/6767906449166354/019fd930-0e81-70d8-8bc5-80d471b09d4c.webp",
        "width": 960,
        "height": 1200
      },
      "poi_business_url": "http://www.buckskids.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10069537202275011216&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-bucks-county-childrens-museum---advance-ticketing-recommended",
      "poi_latitude": "40.366536",
      "poi_longitude": "-74.9564339",
      "poi_miles_from_property": "15.9 mi",
      "poi_walking_minutes": "5 hours 46 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 215-693-1290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-0452-75dd-bb88-49a51df97b60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-0452-75dd-bb88-49a51df97b60",
        "storage_key": "property/6767906449166354/019d026d-0452-75dd-bb88-49a51df97b60.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJbWNOFU7_w4kRkMouGrwuvos",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_57764138-ab22-481b-9dc0-b319f2de74c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Triumph Restaurant & Brewery",
      "poi_type": "Entertainment",
      "poi_address": "400 Union Square Dr, New Hope, PA 18938, USA",
      "poi_short_description": "Eatery & bar's grand, industrial space offers craft beers, burgers, fish 'n' chips & small plates.",
      "poi_long_description": "Eatery & bar's grand, industrial space offers craft beers, burgers, fish 'n' chips & small plates.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-1e13-707a-848b-364d6a69a870.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-1e13-707a-848b-364d6a69a870",
        "storage_key": "property/6767906449166354/019fd930-1e13-707a-848b-364d6a69a870.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.triumphbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1961605616123961463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "triumph-restaurant--brewery",
      "poi_latitude": "40.3651823",
      "poi_longitude": "-74.9538827",
      "poi_miles_from_property": "15.7 mi",
      "poi_walking_minutes": "5 hours 41 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 215-862-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd3d-7659-87ab-ad96dca25ec4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd3d-7659-87ab-ad96dca25ec4",
        "storage_key": "property/6767906449166354/019d026c-fd3d-7659-87ab-ad96dca25ec4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX2Y4QE7_w4kRd-B6MuoFORs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dcf18555-166f-49e7-87f0-02916e8734a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Bucks County Playhouse",
      "poi_type": "Entertainment",
      "poi_address": "70 S Main St, New Hope, PA 18938, USA",
      "poi_short_description": "Former gristmill is now a theater space for musical revivals, dramas, children's shows & live music.",
      "poi_long_description": "Former gristmill is now a theater space for musical revivals, dramas, children's shows & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-1bc9-779c-b90b-ffe1617ad699.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-1bc9-779c-b90b-ffe1617ad699",
        "storage_key": "property/6767906449166354/019fd930-1bc9-779c-b90b-ffe1617ad699.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://bcptheater.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7859602672742682366&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bucks-county-playhouse",
      "poi_latitude": "40.3623964",
      "poi_longitude": "-74.95021059999999",
      "poi_miles_from_property": "15.7 mi",
      "poi_walking_minutes": "5 hours 39 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 215-862-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd31-7551-9eab-7bed21bd7cfd",
        "storage_key": "property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsScNTU__w4kR_s6JKP3qEm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b9dfb2f0-e437-4293-aab1-40130c2137ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Sesame Place Philadelphia",
      "poi_type": "Entertainment",
      "poi_address": "100 Sesame Rd, Langhorne, PA 19047, USA",
      "poi_short_description": "Big Sesame Street-themed amusement park with rides, interactive parade, water slides & Elmo's World.",
      "poi_long_description": "Big Sesame Street-themed amusement park with rides, interactive parade, water slides & Elmo's World.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-2972-74ec-b306-bc09742c221d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-2972-74ec-b306-bc09742c221d",
        "storage_key": "property/6767906449166354/019fd930-2972-74ec-b306-bc09742c221d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sesameplace.com/philadelphia?utm_source=google&utm_medium=organic&utm_campaign=gbp_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12855531197120927059&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sesame-place-philadelphia",
      "poi_latitude": "40.186117",
      "poi_longitude": "-74.8729972",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-702-3566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd31-7551-9eab-7bed21bd7cfd",
        "storage_key": "property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx22iKVlRwYkRU1VYI4MFaLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6acdd6e5-b993-4167-9b47-25775da67105",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Newtown Theatre",
      "poi_type": "Entertainment",
      "poi_address": "120 N State St, Newtown, PA 18940, USA",
      "poi_short_description": "Charming entertainment venue featuring live shows, screenings and private events.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-1f4a-75db-b41f-ded922c9002a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-1f4a-75db-b41f-ded922c9002a",
        "storage_key": "property/6767906449166354/019fd930-1f4a-75db-b41f-ded922c9002a.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "http://thenewtowntheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8756006225444591483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newtown-theatre",
      "poi_latitude": "40.2312186",
      "poi_longitude": "-74.9367194",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd31-7551-9eab-7bed21bd7cfd",
        "storage_key": "property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqer4xexUwYkRe9e7TkWVg3k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fcecfc26-adf4-4d33-85fe-a076f653be18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Washington Crossing Historic Park",
      "poi_type": "Entertainment",
      "poi_address": "1112 River Rd, Washington Crossing, PA 18977, USA",
      "poi_short_description": "Tours are offered of this Revolutionary War site where Washington's army crossed the Delaware River.",
      "poi_long_description": "Tours are offered of this Revolutionary War site where Washington's army crossed the Delaware River.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-2c07-74ac-a6c7-a1ad79af2b4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-2c07-74ac-a6c7-a1ad79af2b4b",
        "storage_key": "property/6767906449166354/019fd930-2c07-74ac-a6c7-a1ad79af2b4b.webp",
        "width": 1280,
        "height": 748
      },
      "poi_business_url": "http://www.washingtoncrossingpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11901342226039778745&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-crossing-historic-park",
      "poi_latitude": "40.29561899999999",
      "poi_longitude": "-74.8718427",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 215-493-4076",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-049e-76f3-afa5-fa62003a1748.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-049e-76f3-afa5-fa62003a1748",
        "storage_key": "property/6767906449166354/019d026d-049e-76f3-afa5-fa62003a1748.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdfywo6xXwYkRuS111bIPKqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9a963fa1-3485-44b1-9a97-f55ad86a455f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "St. Mary Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1201 Langhorne Newtown Rd, Langhorne, PA 19047, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-320b-74ec-9ad5-df0447b6a27d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-320b-74ec-9ad5-df0447b6a27d",
        "storage_key": "property/6767906449166354/019fd930-320b-74ec-9ad5-df0447b6a27d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.trinityhealthma.org/st-mary?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_content=main-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=4473732539720751236&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-mary-medical-center",
      "poi_latitude": "40.2023399",
      "poi_longitude": "-74.9250062",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 215-710-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-04a3-7536-af4d-8d5c1cae57e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-04a3-7536-af4d-8d5c1cae57e7",
        "storage_key": "property/6767906449166354/019d026d-04a3-7536-af4d-8d5c1cae57e7.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJIQJHP3lTwYkRhFgpwgrkFT4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3d0a04d4-9cb3-4257-a845-d60700330dbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Patient Care Now Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "541 S Oxford Valley Rd, Fairless Hills, PA 19030, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-2f3a-759f-b2ad-a7e4ee08ce36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-2f3a-759f-b2ad-a7e4ee08ce36",
        "storage_key": "property/6767906449166354/019fd930-2f3a-759f-b2ad-a7e4ee08ce36.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.patientcarenowurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3313235712812680927&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "patient-care-now-urgent-care",
      "poi_latitude": "40.1688889",
      "poi_longitude": "-74.8488889",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 267-202-6433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd31-7551-9eab-7bed21bd7cfd",
        "storage_key": "property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbYoZmhJRwYkR34ZWl1P6-i0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e50a1426-1095-4692-be1e-c1bee2982032",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Patient First Primary and Urgent Care - Langhorne",
      "poi_type": "Health and Wellness",
      "poi_address": "100 Lincoln Hwy, Fairless Hills, PA 19030, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-3262-725c-9789-4dbbc6472699.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-3262-725c-9789-4dbbc6472699",
        "storage_key": "property/6767906449166354/019fd930-3262-725c-9789-4dbbc6472699.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.patientfirst.com/locations/eastern-pennsylvania/langhorne?utm_source=local&utm_medium=organic&utm_campaign=gbp&y_source=1_NTI1NTU2MjEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17764641528545121535&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "patient-first-primary-and-urgent-care---langhorne",
      "poi_latitude": "40.1803035",
      "poi_longitude": "-74.86913729999999",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 267-587-0775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd31-7551-9eab-7bed21bd7cfd",
        "storage_key": "property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cy3FTJRwYkR_5QVX1mviPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bd92e08e-6926-419e-b71a-18fee5b9edb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "590 W Trenton Ave, Morrisville, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-eeff-71ce-8525-5381c430d54d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92f-eeff-71ce-8525-5381c430d54d",
        "storage_key": "property/6767906449166354/019fd92f-eeff-71ce-8525-5381c430d54d.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/morrisville-pa-pharmacies/590-w-trenton-ave-morrisville-pa-19067/storeid=2568?WT.mc_id=LS_GOOGLE_RX_2568",
      "poi_directions_map_url": "https://maps.google.com/?cid=11413314006546361659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.2083851",
      "poi_longitude": "-74.8021413",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 215-736-9003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-0088-75ee-986d-e6c06f8ef9bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-0088-75ee-986d-e6c06f8ef9bf",
        "storage_key": "property/6767906449166354/019d026d-0088-75ee-986d-e6c06f8ef9bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs7ThwUBXwYkRO60vXp48ZJ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_85b3eceb-1dc9-4a62-993b-9a880d8389ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Primary Care Yardley",
      "poi_type": "Health and Wellness",
      "poi_address": "657 Heacock Rd, Yardley, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-4b20-7558-a1f7-8ade621f566e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-4b20-7558-a1f7-8ade621f566e",
        "storage_key": "property/6767906449166354/019fd930-4b20-7558-a1f7-8ade621f566e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.trinityhealthma.org/location/primary-care-fairless-hills?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_content=main-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=10472962822230158845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primary-care-yardley",
      "poi_latitude": "40.2213313",
      "poi_longitude": "-74.8719704",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-750-7150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd31-7551-9eab-7bed21bd7cfd",
        "storage_key": "property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1_H7Hw5RwYkR_a3m3DJwV5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4073682e-dec4-4459-b84a-8fa2e8042175",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "229 Plaza Blvd, Morrisville, PA 19067, USA",
      "poi_short_description": "Chain gym featuring treadmills, tanning beds and other machines in a huge, clean space with lockers, showers and attentive service.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-384f-70ba-a8f3-5e40dcce7848.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-384f-70ba-a8f3-5e40dcce7848",
        "storage_key": "property/6767906449166354/019fd930-384f-70ba-a8f3-5e40dcce7848.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/morrisville-pa?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=8165157896907888731&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "40.2059135",
      "poi_longitude": "-74.80235490000001",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 267-797-5055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd31-7551-9eab-7bed21bd7cfd",
        "storage_key": "property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPeIqPkdXwYkRW5grrNh3UHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_02d44721-911a-4e36-88ae-4e71f339f09e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Pennsbury Racquet Club",
      "poi_type": "Health and Wellness",
      "poi_address": "375 W Trenton Ave, Morrisville, PA 19067, USA",
      "poi_short_description": "Athletic club offering tennis instruction and facilities for tournaments.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-4e08-7068-9c3b-4f9753cf3cb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-4e08-7068-9c3b-4f9753cf3cb6",
        "storage_key": "property/6767906449166354/019fd930-4e08-7068-9c3b-4f9753cf3cb6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.pennsburyrac.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8479104338955399116&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pennsbury-racquet-club",
      "poi_latitude": "40.2079564",
      "poi_longitude": "-74.7978418",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 215-736-1177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd31-7551-9eab-7bed21bd7cfd",
        "storage_key": "property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ81vLgEFXwYkRzO_o2HjUq3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_079ea1d0-7554-42b2-95e7-ddf8208077e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Witt Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "10 Penn Valley Dr, Yardley, PA 19067, USA",
      "poi_short_description": "Relaxed studio featuring mat, tower & Reformer Pilates sessions, plus cycling & barre classes.",
      "poi_long_description": "Relaxed studio featuring mat, tower & Reformer Pilates sessions, plus cycling & barre classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-421b-72f3-a2c7-b9f9e668998a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-421b-72f3-a2c7-b9f9e668998a",
        "storage_key": "property/6767906449166354/019fd930-421b-72f3-a2c7-b9f9e668998a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://wittpilates.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13720557034726231992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "witt-pilates",
      "poi_latitude": "40.2416788",
      "poi_longitude": "-74.8404164",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 267-391-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-009b-744a-bc03-5b3618299d47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-009b-744a-bc03-5b3618299d47",
        "storage_key": "property/6767906449166354/019d026d-009b-744a-bc03-5b3618299d47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTWo7kllWwYkRuA9Yr-01ab4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f1812f37-94d7-4df0-9fe3-1f908487630a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Integrative Fitness Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "301 Oxford Valley Rd suite. 1503, Yardley, PA 19067, USA",
      "poi_short_description": "Pilates studio offering classes and private sessions, plus online instruction.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-5367-737a-939a-50993e687dbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-5367-737a-939a-50993e687dbb",
        "storage_key": "property/6767906449166354/019fd930-5367-737a-939a-50993e687dbb.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.ifspilates.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8298013906967544957&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "integrative-fitness-pilates",
      "poi_latitude": "40.2075954",
      "poi_longitude": "-74.8678906",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 267-907-2140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-009b-744a-bc03-5b3618299d47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-009b-744a-bc03-5b3618299d47",
        "storage_key": "property/6767906449166354/019d026d-009b-744a-bc03-5b3618299d47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIyCir65WwYkRfUQNAq93KHM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6181c62d-3f51-49fb-a1c8-ce58589982a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "ShopRite Pharmacy of Yardley",
      "poi_type": "Health and Wellness",
      "poi_address": "1603 Big Oak Rd, Yardley, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-4a18-726d-acdd-d26b43b8054f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-4a18-726d-acdd-d26b43b8054f",
        "storage_key": "property/6767906449166354/019fd930-4a18-726d-acdd-d26b43b8054f.webp",
        "width": 600,
        "height": 600
      },
      "poi_business_url": "https://www.shoprite.com/pharmacy/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5562318238351042677&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shoprite-pharmacy-of-yardley",
      "poi_latitude": "40.198262",
      "poi_longitude": "-74.8629574",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 215-595-0080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-0088-75ee-986d-e6c06f8ef9bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-0088-75ee-986d-e6c06f8ef9bf",
        "storage_key": "property/6767906449166354/019d026d-0088-75ee-986d-e6c06f8ef9bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6W1Fj1JRwYkRdSiXpPdSMU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d769fd54-4f89-47bc-87a5-8f893024bf54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Williamson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "97 N Delmorr Ave, Morrisville, PA 19067, USA",
      "poi_short_description": "Large park for riverfront views and baseball and softball fields and shows, plus playgrounds.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-602f-72d9-aea6-6b52ddafa258.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-602f-72d9-aea6-6b52ddafa258",
        "storage_key": "property/6767906449166354/019fd930-602f-72d9-aea6-6b52ddafa258.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7407017967555214649&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "williamson-park",
      "poi_latitude": "40.2110524",
      "poi_longitude": "-74.7737691",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-049e-76f3-afa5-fa62003a1748.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-049e-76f3-afa5-fa62003a1748",
        "storage_key": "property/6767906449166354/019d026d-049e-76f3-afa5-fa62003a1748.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0QRyKE1ZwYkROX0Q8ZgDy2Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bb13772d-b302-46c0-9f2c-64baecd58870",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Cleveland Ave Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "98 Penn Ave, Morrisville, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-6bf2-707d-b487-81b47d2e407c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-6bf2-707d-b487-81b47d2e407c",
        "storage_key": "property/6767906449166354/019fd930-6bf2-707d-b487-81b47d2e407c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1142956498865439824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cleveland-ave-park",
      "poi_latitude": "40.20227999999999",
      "poi_longitude": "-74.770031",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-049e-76f3-afa5-fa62003a1748.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-049e-76f3-afa5-fa62003a1748",
        "storage_key": "property/6767906449166354/019d026d-049e-76f3-afa5-fa62003a1748.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJI2U75uVZwYkRUESZTOGY3A8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fe1d7f64-1032-4405-9c72-1392d6b47aa2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Penn’s Grant Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Yardley, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-70c0-7199-b94a-34fcfcbed8bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-70c0-7199-b94a-34fcfcbed8bd",
        "storage_key": "property/6767906449166354/019fd930-70c0-7199-b94a-34fcfcbed8bd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7192998799227729089&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "penns-grant-park",
      "poi_latitude": "40.2009683",
      "poi_longitude": "-74.8193852",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-049e-76f3-afa5-fa62003a1748.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-049e-76f3-afa5-fa62003a1748",
        "storage_key": "property/6767906449166354/019d026d-049e-76f3-afa5-fa62003a1748.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJtWU3dMNXwYkRwbTHOUyq0mM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_aa345b73-ed32-4fcf-aaa9-fb813c558f2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Boat Ramp at Quaker Penn Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 Pennsbury Memorial Rd, Morrisville, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-6b26-775e-84fb-8ad70fd80355.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-6b26-775e-84fb-8ad70fd80355",
        "storage_key": "property/6767906449166354/019fd930-6b26-775e-84fb-8ad70fd80355.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fallstwp.com/departments/parks-recreation/quaker-penn-park-boat-launch-pass.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=11746333382566882508&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boat-ramp-at-quaker-penn-park",
      "poi_latitude": "40.1293442",
      "poi_longitude": "-74.77561",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 215-949-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd31-7551-9eab-7bed21bd7cfd",
        "storage_key": "property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwV75RJ9awYkRzCw2CfpbA6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4e104a64-e239-4b90-b90f-b01e94d5cf8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Delaware Canal Ferry Road Access",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "140-168 E Ferry Rd, Morrisville, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-b16b-71b8-b05e-d9624b9b74b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-b16b-71b8-b05e-d9624b9b74b7",
        "storage_key": "property/6767906449166354/019fd930-b16b-71b8-b05e-d9624b9b74b7.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.dcnr.pa.gov/StateParks/FindAPark/DelawareCanalStatePark/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=14628593609020181723&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "delaware-canal-ferry-road-access",
      "poi_latitude": "40.2204311",
      "poi_longitude": "-74.7864391",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-049e-76f3-afa5-fa62003a1748.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-049e-76f3-afa5-fa62003a1748",
        "storage_key": "property/6767906449166354/019d026d-049e-76f3-afa5-fa62003a1748.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJi1bciklXwYkR24wyvWE0A8s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_446e7e2f-1323-4fc9-bbaf-8ec467c59880",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Delaware Canal Morrisville Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "350 Delaware Canal Towpath, Morrisville, PA 19067, USA",
      "poi_short_description": "Peaceful trail along the Delaware River with views of fish, birds, turtles and deer.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-8c6d-7518-8c0f-bfafd07bd49b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-8c6d-7518-8c0f-bfafd07bd49b",
        "storage_key": "property/6767906449166354/019fd930-8c6d-7518-8c0f-bfafd07bd49b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.dcnr.state.pa.us/stateparks/findapark/delawarecanal/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13766624619633557403&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "delaware-canal-morrisville-trailhead",
      "poi_latitude": "40.21810560000001",
      "poi_longitude": "-74.7798432",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 610-982-5560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-049e-76f3-afa5-fa62003a1748.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-049e-76f3-afa5-fa62003a1748",
        "storage_key": "property/6767906449166354/019d026d-049e-76f3-afa5-fa62003a1748.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJi_2aDdhZwYkRm79nISfgDL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_411e536e-8442-44fb-9e10-5c4b506fb463",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Morrisville Riverfront Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "South Delmorr Avenue &, E Philadelphia Ave, Morrisville, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-8a79-774f-8c1b-f241b1af8a84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-8a79-774f-8c1b-f241b1af8a84",
        "storage_key": "property/6767906449166354/019fd930-8a79-774f-8c1b-f241b1af8a84.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7567482751858890893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morrisville-riverfront-preserve",
      "poi_latitude": "40.2057463",
      "poi_longitude": "-74.7685068",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-049e-76f3-afa5-fa62003a1748.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-049e-76f3-afa5-fa62003a1748",
        "storage_key": "property/6767906449166354/019d026d-049e-76f3-afa5-fa62003a1748.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJoWK_VwBZwYkRjdhx9HcZBWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6f342f4f-cca5-465f-ba05-3e8259b4c802",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Morrisville Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "E Philadelphia Ave, Morrisville, PA 19067, USA",
      "poi_short_description": "Green space where dogs can run and socialize, with benches, river views, and a water fountain.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-8cbc-754e-b1bc-c52962a93443.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-8cbc-754e-b1bc-c52962a93443",
        "storage_key": "property/6767906449166354/019fd930-8cbc-754e-b1bc-c52962a93443.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://morrisvilledogpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8509548003182932407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morrisville-dog-park",
      "poi_latitude": "40.2054672",
      "poi_longitude": "-74.7698729",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-295-1045",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-049e-76f3-afa5-fa62003a1748.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-049e-76f3-afa5-fa62003a1748",
        "storage_key": "property/6767906449166354/019d026d-049e-76f3-afa5-fa62003a1748.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBbvcyudZwYkRt3HayNL8F3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cf220865-57ef-4ace-a470-acc5aa587907",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Washington Crossing Historic Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1112 River Rd, Washington Crossing, PA 18977, USA",
      "poi_short_description": "Tours are offered of this Revolutionary War site where Washington's army crossed the Delaware River.",
      "poi_long_description": "Tours are offered of this Revolutionary War site where Washington's army crossed the Delaware River.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-2c07-74ac-a6c7-a1ad79af2b4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-2c07-74ac-a6c7-a1ad79af2b4b",
        "storage_key": "property/6767906449166354/019fd930-2c07-74ac-a6c7-a1ad79af2b4b.webp",
        "width": 1280,
        "height": 748
      },
      "poi_business_url": "http://www.washingtoncrossingpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11901342226039778745&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-crossing-historic-park",
      "poi_latitude": "40.29561899999999",
      "poi_longitude": "-74.8718427",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 215-493-4076",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-049e-76f3-afa5-fa62003a1748.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-049e-76f3-afa5-fa62003a1748",
        "storage_key": "property/6767906449166354/019d026d-049e-76f3-afa5-fa62003a1748.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdfywo6xXwYkRuS111bIPKqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cc0aa60f-451e-41f0-ade0-40efae316b88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Bowman's Hill Wildflower Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1635 River Rd, New Hope, PA 18938, USA",
      "poi_short_description": "This 134-acre wildflower preserve features over 800 plant species native to the Delaware Valley.",
      "poi_long_description": "This 134-acre wildflower preserve features over 800 plant species native to the Delaware Valley.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-94af-765e-8e36-64a97dab50b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-94af-765e-8e36-64a97dab50b8",
        "storage_key": "property/6767906449166354/019fd930-94af-765e-8e36-64a97dab50b8.webp",
        "width": 860,
        "height": 768
      },
      "poi_business_url": "http://www.bhwp.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16707827727708079587&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bowmans-hill-wildflower-preserve",
      "poi_latitude": "40.331366",
      "poi_longitude": "-74.93919799999999",
      "poi_miles_from_property": "12.4 mi",
      "poi_walking_minutes": "4 hours 31 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 215-862-2924",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-049e-76f3-afa5-fa62003a1748.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-049e-76f3-afa5-fa62003a1748",
        "storage_key": "property/6767906449166354/019d026d-049e-76f3-afa5-fa62003a1748.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCxdvFwr_w4kR40V25ssg3uc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c01ffa27-48e4-4a37-912c-a56b2ae2dd17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Yardley Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "13 Reading Ave, Yardley, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-a1b3-7739-bf43-ef0d2a97608c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-a1b3-7739-bf43-ef0d2a97608c",
        "storage_key": "property/6767906449166354/019fd930-a1b3-7739-bf43-ef0d2a97608c.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.septa.org/stations/yardley-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=13263183721745051089&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yardley-station",
      "poi_latitude": "40.2353186",
      "poi_longitude": "-74.8311729",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-580-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-05fe-71dc-835e-adb72d9a5e6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-05fe-71dc-835e-adb72d9a5e6b",
        "storage_key": "property/6767906449166354/019d026d-05fe-71dc-835e-adb72d9a5e6b.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJlcMLb_9WwYkR0W1b1VJLELg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b16eebde-4ca5-4ce7-b5d3-9e373cfbf995",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Trenton Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "72 S Clinton Ave, Trenton, NJ 08609, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-a365-712d-b968-601460ae76bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-a365-712d-b968-601460ae76bc",
        "storage_key": "property/6767906449166354/019fd930-a365-712d-b968-601460ae76bc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=TRE",
      "poi_directions_map_url": "https://maps.google.com/?cid=11253055944879228757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trenton-transit-center",
      "poi_latitude": "40.21879980000001",
      "poi_longitude": "-74.7543266",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-089f-71ab-9740-ba21d94cfba4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-089f-71ab-9740-ba21d94cfba4",
        "storage_key": "property/6767906449166354/019d026d-089f-71ab-9740-ba21d94cfba4.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJj1lF_rZZwYkRVccfuMLiKpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ae163466-ea63-4ad0-9629-45d087c30c9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Cornwells Heights",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 Station Ave, Cornwells Heights, PA 19020, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-9df4-75f6-952c-a9facfeae351.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-9df4-75f6-952c-a9facfeae351",
        "storage_key": "property/6767906449166354/019fd930-9df4-75f6-952c-a9facfeae351.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=CWH",
      "poi_directions_map_url": "https://maps.google.com/?cid=6212064149205362683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cornwells-heights",
      "poi_latitude": "40.0717332",
      "poi_longitude": "-74.9520986",
      "poi_miles_from_property": "15.4 mi",
      "poi_walking_minutes": "5 hours 41 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-089f-71ab-9740-ba21d94cfba4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-089f-71ab-9740-ba21d94cfba4",
        "storage_key": "property/6767906449166354/019d026d-089f-71ab-9740-ba21d94cfba4.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJK3zxxrhMwYkR-ydTR26vNVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_089eba76-99c3-4a5d-b50f-6fb5f2d96272",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "West Trenton",
      "poi_type": "Transportation & Transit",
      "poi_address": "3 Railroad Ave, Trenton, NJ 08628, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-b437-77fc-b205-dacafe27c308.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-b437-77fc-b205-dacafe27c308",
        "storage_key": "property/6767906449166354/019fd930-b437-77fc-b205-dacafe27c308.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://septa.org/stations/rail/westtrenton.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=17328819319881630318&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-trenton",
      "poi_latitude": "40.2573574",
      "poi_longitude": "-74.81564399999999",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 215-580-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-089f-71ab-9740-ba21d94cfba4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-089f-71ab-9740-ba21d94cfba4",
        "storage_key": "property/6767906449166354/019d026d-089f-71ab-9740-ba21d94cfba4.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJKVUpH8ZXwYkRboJ4AlxVfPA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_61ead883-303f-4599-b426-86dfee1dde3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Levittown Train Station Ticket Office",
      "poi_type": "Transportation & Transit",
      "poi_address": "8301 Bristol Pike, Levittown, PA 19054, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-ac17-7735-ad7e-1ef3b40ce3c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-ac17-7735-ad7e-1ef3b40ce3c9",
        "storage_key": "property/6767906449166354/019fd930-ac17-7735-ad7e-1ef3b40ce3c9.webp",
        "width": 1280,
        "height": 403
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2307715567692096953&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "levittown-train-station-ticket-office",
      "poi_latitude": "40.1402236",
      "poi_longitude": "-74.8172687",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-946-4251",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd31-7551-9eab-7bed21bd7cfd",
        "storage_key": "property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv4frsnJRwYkRuSXt_hSnBiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d84e4845-0f24-43c4-a5a5-39d7e84dc6ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Trenton-Mercer Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1100 Terminal Cir Dr, Ewing Township, NJ 08628, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-b48a-70b9-b311-54aa5bceba8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-b48a-70b9-b311-54aa5bceba8d",
        "storage_key": "property/6767906449166354/019fd930-b48a-70b9-b311-54aa5bceba8d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.flytrentonmercer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14865279647832479002&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trenton-mercer-airport",
      "poi_latitude": "40.2770583",
      "poi_longitude": "-74.81811909999999",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 609-882-1601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-08a5-76bc-a3a9-bcfc40a086e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-08a5-76bc-a3a9-bcfc40a086e6",
        "storage_key": "property/6767906449166354/019d026d-08a5-76bc-a3a9-bcfc40a086e6.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJaUy3GmP9w4kRGhXmfxQVTM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bacc83ac-0a18-4f29-ab8f-e3a016bfdb61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Morrisville Borough Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "35 Union St, Morrisville, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-b79c-710d-b9b0-de55abe2d1ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-b79c-710d-b9b0-de55abe2d1ac",
        "storage_key": "property/6767906449166354/019fd930-b79c-710d-b9b0-de55abe2d1ac.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://morrisvillepagov.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1703681180194206333&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morrisville-borough-hall",
      "poi_latitude": "40.2101263",
      "poi_longitude": "-74.7752761",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 215-295-8181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-0959-749a-a6bf-64c45df8bd45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-0959-749a-a6bf-64c45df8bd45",
        "storage_key": "property/6767906449166354/019d026d-0959-749a-a6bf-64c45df8bd45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP-UMct5ZwYkRfXL-wwGxpBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cbb341de-5b11-4434-b0f9-ebc0bcc81637",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "New Jersey State House",
      "poi_type": "Major Employers & Offices",
      "poi_address": "125 W State St, Trenton, NJ 08608, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-ca06-7139-9158-4b503dc4c719.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-ca06-7139-9158-4b503dc4c719",
        "storage_key": "property/6767906449166354/019fd930-ca06-7139-9158-4b503dc4c719.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nj.gov/grc/pdf/Capitol%20Complex%20Map.pdf",
      "poi_directions_map_url": "https://maps.google.com/?cid=9651486689541619460&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-jersey-state-house",
      "poi_latitude": "40.2205196",
      "poi_longitude": "-74.7699786",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 609-292-5217",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-0959-749a-a6bf-64c45df8bd45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-0959-749a-a6bf-64c45df8bd45",
        "storage_key": "property/6767906449166354/019d026d-0959-749a-a6bf-64c45df8bd45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJke0-fSxZwYkRBP-JJAL48IU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7e5b511a-3873-4894-80f7-230bae7b5573",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Joyce McDade Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "640 S Broad St, Trenton, NJ 08611, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-ce40-7672-8be2-cf56a168239f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-ce40-7672-8be2-cf56a168239f",
        "storage_key": "property/6767906449166354/019fd930-ce40-7672-8be2-cf56a168239f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mercercounty.org/departments/personnel/contact-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=12754145228086621326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joyce-mcdade-administration-building",
      "poi_latitude": "40.2092758",
      "poi_longitude": "-74.754224",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 609-989-6676",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-0959-749a-a6bf-64c45df8bd45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-0959-749a-a6bf-64c45df8bd45",
        "storage_key": "property/6767906449166354/019d026d-0959-749a-a6bf-64c45df8bd45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOZqGHr9ZwYkRjrTYtYLT_7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_21eb4b9f-2b24-4cdd-b478-8dc3b8008ec7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Princeton Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Plainsboro Rd, Plainsboro Township, NJ 08536, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-cb2f-70dd-a5a6-89b36742f3c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-cb2f-70dd-a5a6-89b36742f3c6",
        "storage_key": "property/6767906449166354/019fd930-cb2f-70dd-a5a6-89b36742f3c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pennmedicine.org/Locations/Entity/Princeton-Health?y_source=1_MjM4NTY4MzYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13006348941527410712&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "princeton-medical-center",
      "poi_latitude": "40.34033429999999",
      "poi_longitude": "-74.62379460000001",
      "poi_miles_from_property": "14.3 mi",
      "poi_walking_minutes": "5 hours 14 mins",
      "poi_biking_minutes": "1 hour 33 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 609-853-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd31-7551-9eab-7bed21bd7cfd",
        "storage_key": "property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZygHSOvmw4kRGOiEpHPVf7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bfea68d6-b8be-4f42-9dc4-d913ce48fdb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Capital Health Regional Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "750 Brunswick Ave, Trenton, NJ 08638, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-c0a1-731f-9bc8-0d9c56163276.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-c0a1-731f-9bc8-0d9c56163276",
        "storage_key": "property/6767906449166354/019fd930-c0a1-731f-9bc8-0d9c56163276.webp",
        "width": 844,
        "height": 475
      },
      "poi_business_url": "https://www.capitalhealth.org/our-locations/regional-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=11596362478796508657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "capital-health-regional-medical-center",
      "poi_latitude": "40.2359745",
      "poi_longitude": "-74.7518",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 609-394-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-04a3-7536-af4d-8d5c1cae57e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-04a3-7536-af4d-8d5c1cae57e7",
        "storage_key": "property/6767906449166354/019d026d-04a3-7536-af4d-8d5c1cae57e7.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJpajlBEZYwYkR8Y1V-zuO7qA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3d36105a-ff3f-4e28-bedb-34181338f1f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Lower Bucks Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "501 Bath Rd, Bristol, PA 19007, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-ca46-7419-919d-a0fade676e02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-ca46-7419-919d-a0fade676e02",
        "storage_key": "property/6767906449166354/019fd930-ca46-7419-919d-a0fade676e02.webp",
        "width": 1280,
        "height": 871
      },
      "poi_business_url": "https://lowerbuckshosp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10385465491232408324&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lower-bucks-hospital",
      "poi_latitude": "40.1055711",
      "poi_longitude": "-74.8674966",
      "poi_miles_from_property": "11.0 mi",
      "poi_walking_minutes": "4 hours 3 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 215-785-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-04a3-7536-af4d-8d5c1cae57e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-04a3-7536-af4d-8d5c1cae57e7",
        "storage_key": "property/6767906449166354/019d026d-04a3-7536-af4d-8d5c1cae57e7.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJpSLAGQxOwYkRBEP899aVIJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_49759dfb-437b-4d4c-b16b-86dcc9d3b0d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Nassau Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Rivers Wy, Princeton, NJ 08542, USA",
      "poi_short_description": "Built in 1756, this historic building features a memorial atrium & a faculty room for school admins.",
      "poi_long_description": "Built in 1756, this historic building features a memorial atrium & a faculty room for school admins.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-e30d-77fc-9e0c-ce09b1736cf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-e30d-77fc-9e0c-ce09b1736cf7",
        "storage_key": "property/6767906449166354/019fd930-e30d-77fc-9e0c-ce09b1736cf7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://princetoniana.princeton.edu/campus/nassau-hall",
      "poi_directions_map_url": "https://maps.google.com/?cid=2148953420913683496&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nassau-hall",
      "poi_latitude": "40.3486278",
      "poi_longitude": "-74.6593444",
      "poi_miles_from_property": "13.2 mi",
      "poi_walking_minutes": "4 hours 51 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd31-7551-9eab-7bed21bd7cfd",
        "storage_key": "property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD43BPsHmw4kRKKxrLMCd0h0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_74c30814-2773-4bd8-8013-46d5a3ae6252",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Bristol Myers Squibb",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3551 Lawrenceville Rd, Lawrence Township, NJ 08648, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-dc83-723a-8300-f5d680cc6ea2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-dc83-723a-8300-f5d680cc6ea2",
        "storage_key": "property/6767906449166354/019fd930-dc83-723a-8300-f5d680cc6ea2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.bms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=179401083201396625&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bristol-myers-squibb",
      "poi_latitude": "40.32154370000001",
      "poi_longitude": "-74.7063627",
      "poi_miles_from_property": "11.3 mi",
      "poi_walking_minutes": "4 hours 12 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 800-332-2056",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd31-7551-9eab-7bed21bd7cfd",
        "storage_key": "property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmb7wWnDhw4kRkR-KrFVcfQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d92f1f79-bfc4-45d5-a339-f86cdfeca512",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Princeton Plasma Physics Laboratory",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Stellarator Rd, Princeton, NJ 08540, USA",
      "poi_short_description": "Fusion, science and physics laboratory with friendly staff, offering tours for the public.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-d551-716c-ba46-6b87e2849cae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-d551-716c-ba46-6b87e2849cae",
        "storage_key": "property/6767906449166354/019fd930-d551-716c-ba46-6b87e2849cae.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.pppl.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5317700660360916858&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "princeton-plasma-physics-laboratory",
      "poi_latitude": "40.3506062",
      "poi_longitude": "-74.6028491",
      "poi_miles_from_property": "15.6 mi",
      "poi_walking_minutes": "5 hours 42 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 609-243-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd31-7551-9eab-7bed21bd7cfd",
        "storage_key": "property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlYFaC8Hmw4kRei-sgpNEzEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d7821e6b-c40a-4115-a6cd-718dba181af3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "poi_name": "Woods Services and Woods System of Care",
      "poi_type": "Major Employers & Offices",
      "poi_address": "40 Martin Gross Dr, Langhorne, PA 19047, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-e3c2-774b-940d-4013d576127f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd930-e3c2-774b-940d-4013d576127f",
        "storage_key": "property/6767906449166354/019fd930-e3c2-774b-940d-4013d576127f.webp",
        "width": 1280,
        "height": 867
      },
      "poi_business_url": "http://www.woods.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4528934966245223408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woods-services-and-woods-system-of-care",
      "poi_latitude": "40.1749946",
      "poi_longitude": "-74.9081778",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 215-750-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026c-fd31-7551-9eab-7bed21bd7cfd",
        "storage_key": "property/6767906449166354/019d026c-fd31-7551-9eab-7bed21bd7cfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjYMYJaVTwYkR8GvkQVsC2j4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [],
  "reviews": [
    {
      "id": "ec_e293a89bc9fe54c8de7a1039",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "rating": "5",
      "name": "Ezekiel Breza",
      "text": "My experience at the Nolan so far has been pleasant, smooth, and stress free. Kevin the leasing manager is very easy to get in contact with and is extremely timely with his responses. The property itself is very well maintained and the maintenance team themselves are quick to solve any issues.",
      "date": "2025-06-08",
      "title": "false"
    },
    {
      "id": "ec_c5a2656c4a36efcce8fb3683",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "rating": "5",
      "name": "Priti Dhiman",
      "text": "Have been living at the Nolan for 6 months now and I absolutely love it. From the property manager, Kevin, who made the application process seamless to the punctual service request response, it has been nothing but awesome. Area is quiet and still located conveniently from NJ and all the shopping centers in the area. Would highly recommend renting here.",
      "date": "2025-04-24",
      "title": "false"
    },
    {
      "id": "ec_04ff149c56ba49032db5d26c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "rating": "5",
      "name": "Kim Dao",
      "text": "The Nolan might have been my best rental experience. Kevin makes the move-in/move-out process go smoothly. Ken, the maintenance guy, is amazing. He responds quickly to requests. Sometimes we got our maintenance requests taken care of within the day or even hours.",
      "date": "2024-12-25",
      "title": "false"
    },
    {
      "id": "ec_c4c7707fe5871a6da76c32e2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "rating": "5",
      "name": "Shae Nance",
      "text": "I absolutely love it here. I have lived here for almost a year and Kevin and Ken are AWESOME! Kevin made the application and move in process easy for me and has been very supportive since then. Ken is always around and on top of any hiccups you may acquire. They are literally a phone call away. People are friendly and always speaking and it is very nice always seeing people with their dogs and their kids outside playing! It is very peaceful here.",
      "date": "2024-08-17",
      "title": "false"
    },
    {
      "id": "ec_8ddb7840343942e2074aeec9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "rating": "5",
      "name": "Drew Slater",
      "text": "I have been living here for a little over two years and have had no complaints, Kevin and Ken have been fantastic to us and help us out with any problems in a timely and efficient manner. Our neighbors have been fantastic, looking forward to another year here at least!",
      "date": "2024-10-19",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "fees": [
    {
      "id": "ec_54b9e90deb9f253d71d39a25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "engrain",
      "external_id": "429667",
      "name": "Insurance",
      "description": "false",
      "amount": 14,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "insurance",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_647438b4b838ad4bfef2a636",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "engrain",
      "external_id": "429668",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1e8a5988c03cae46e08b7163",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "engrain",
      "external_id": "429669",
      "name": "Pet Fee",
      "description": "false",
      "amount": 300,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4adf42cef86a0e5adb2063d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "engrain",
      "external_id": "429671",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_78bb53a5bf028c0e8f724108",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "engrain",
      "external_id": "429672",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_60256042195f120dd3f40d87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "engrain",
      "external_id": "429673",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "50.00 / 25.00",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a3b0aee374a7fee537c3e602",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "engrain",
      "external_id": "429677",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a644dd488418a6a0e686675a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "engrain",
      "external_id": "429678",
      "name": "Transfer Fee",
      "description": "false",
      "amount": 500,
      "amount_max": 1000,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_022eeadb790734c285f63dcb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "engrain",
      "external_id": "429679",
      "name": "Storage Space",
      "description": "false",
      "amount": 20,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "storage",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4313b00fadbc3f111ccdb455",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "engrain",
      "external_id": "572089",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_9c718f1b2b62358d7a477db9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "engrain",
      "external_id": "572090",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_ec03a798aca496eca76ccd99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "engrain",
      "external_id": "572092",
      "name": "Trash Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Varies",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_9434dbf01ad92a816580bcb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "engrain",
      "external_id": "572094",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_55f78356209915759c29da5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "engrain",
      "external_id": "572095",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_fc9a46bb1ef3e5435b1bca10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "engrain",
      "external_id": "572098",
      "name": "Utility - Administrative Billing Fee",
      "description": "false",
      "amount": 4.66,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_aa251ae89ee2f4fe6fbc97ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "engrain",
      "external_id": "832556",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_3a9e966a7d411177c3ffd7ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "engrain",
      "external_id": "832559",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_56cdfaca2901f21654b51911",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "engrain",
      "external_id": "832561",
      "name": "Certificate of Occupancy Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_baceada9c54ef3c62cf5b8af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "engrain",
      "external_id": "832568",
      "name": "Lockout Fee - After Hours",
      "description": "false",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c059d9f827dd64446672a508",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "engrain",
      "external_id": "832570",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a2884-8afd-757a-850d-c7f75e4210f6",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-the-nolan-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354"
    },
    {
      "lead_collector_id": "019c3043-b243-7698-a846-8fc060ec526d",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-nolan",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354"
    },
    {
      "lead_collector_id": "019c3043-b2b2-75ef-baaa-42555dd64126",
      "lead_source": "LANDING_PAGE",
      "name": "the-nolan",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-morrisville-pa-the-nolan-412",
      "search_query": "in unit laundry apartments morrisville pa",
      "category": "Amenity",
      "h1_title": "In Unit Laundry Apts in Morrisville, PA",
      "h2_subtitle": "Discover the convenience of in unit laundry apartments in Morrisville, PA. The Nolan offers this modern amenity in select units for your comfort.",
      "page_copy": "At The Nolan in Morrisville, PA, enjoy the luxury of in unit laundry, making daily chores a breeze. Our apartment community features one and two-bedroom layouts, with select units equipped with washers and dryers right inside your home. This added convenience allows you more time to relax and enjoy our beautifully landscaped, park-like settings without leaving the comfort of your apartment.\n\nOur residents appreciate the combination of convenience and style, with modern finishes and pet-friendly accommodations. The Nolan also enhances your living experience with flexible rent payment options and online maintenance requests. Located in the heart of Bucks County, immerse yourself in a community that values comfort and efficiency. Schedule a tour today to see our in unit laundry amenities firsthand!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In Unit Laundry Apts Morrisville, PA - The Nolan",
      "seo_description": "Enjoy in unit laundry in select units at The Nolan in Morrisville, PA. Convenience meets comfort in our spacious homes. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-bucks-county-the-nolan-232",
      "search_query": "pet friendly apartments bucks county",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Bucks County",
      "h2_subtitle": "Explore pet friendly apartments in Bucks County, perfect for you and your furry friend. The Nolan welcomes all pets with open arms and amenities.",
      "page_copy": "Embrace pet-friendly living at The Nolan in Bucks County. Our apartments offer welcoming spaces tailored for you and your furry companions. With beautifully landscaped grounds, it's the perfect setting for daily walks and outdoor enjoyment with your pet.\n\nWe understand that pets are family, which is why we ensure your living experience is stress-free with features like ample parking and a park-like setting. Located in the heart of Morrisville, PA, The Nolan provides spacious one and two-bedroom homes with modern finishes, complemented by the convenience of online maintenance requests and flexible rent payments. Your pets will feel right at home, and so will you!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments Bucks County - The Nolan",
      "seo_description": "Find pet-friendly living at The Nolan in Bucks County. Spacious homes with amenities for you and your furry friend. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "apartments-with-parking-morrisville-pa-the-nolan-890",
      "search_query": "apartments with parking morrisville pa",
      "category": "Amenity",
      "h1_title": "Apartments with Parking in Morrisville, PA",
      "h2_subtitle": "Find apartments with parking in Morrisville, PA at The Nolan. Enjoy ample spaces that complement our modern, convenient amenities.",
      "page_copy": "At The Nolan in Morrisville, PA, parking is as hassle-free as living in our modern apartments. Our community offers abundant parking spaces, ensuring that you always have a convenient spot waiting for you. This amenity complements our beautifully designed one and two-bedroom apartments, providing you with the seamless lifestyle you desire.\n\nLocated in scenic Bucks County, The Nolan combines comfort with practicality. Our park-like setting and pet-friendly policies enhance your quality of life. Enjoy the flexibility of online maintenance requests and easy rent payment options, all within a community that values accessibility and ease. Experience the perfect blend of convenience and style by choosing The Nolan today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Morrisville Apartments with Parking - The Nolan",
      "seo_description": "Discover convenient parking at The Nolan in Morrisville, PA. Spacious apartments with modern amenities and ample parking await you. Schedule a visit!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "apartments-with-air-conditioning-pennsbury-school-district-the-nolan-849",
      "search_query": "apartments with air conditioning pennsbury school district",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apts in Pennsbury School District",
      "h2_subtitle": "Discover air conditioned apartments within the Pennsbury School District. Stay comfortable year-round at The Nolan, located in a prime school zone.",
      "page_copy": "Enjoy year-round comfort at The Nolan, offering air-conditioned apartments within the coveted Pennsbury School District. Our spacious one and two-bedroom homes ensure you and your family enjoy optimal living conditions, from modern finishes to temperature control.\n\nLocated in Morrisville, PA, The Nolan provides easy access to excellent educational institutions while ensuring premium living with amenities like in-unit washers and dryers, ample parking, and pet-friendly spaces. Experience the perfect setting for families seeking quality education and comfortable living environments. Schedule a tour today to explore our air-conditioned apartments and discover why The Nolan is the perfect choice.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "AC Apartments Pennsbury School District - The Nolan",
      "seo_description": "Stay cool in air conditioned apartments at The Nolan, in the Pennsbury School District. Ideal family living with modern comforts. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "apartments-with-dishwasher-near-septa-yardley-station-the-nolan-725",
      "search_query": "apartments with dishwasher near septa yardley station",
      "category": "Amenity",
      "h1_title": "Apts with Dishwashers Near Yardley SEPTA",
      "h2_subtitle": "Find apartments with dishwashers near SEPTA Yardley Station. The Nolan offers modern conveniences in a prime commuting location.",
      "page_copy": "Discover the convenience of living at The Nolan, where select apartments come equipped with dishwashers and are just minutes from SEPTA Yardley Station. Located in Morrisville, PA, our one and two-bedroom homes provide a seamless living experience, ideal for those who commute and appreciate modern upgrades.\n\nEnjoy the comfort of contemporary finishes and essential amenities like in-unit laundry, ample parking, and a park-like setting. At The Nolan, you can have it all—efficient kitchen appliances and easy access to public transport, making daily travel a breeze. Explore The Nolan today and secure a home that caters to both your lifestyle and commuting needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Dishwashers Near Yardley Station - The Nolan",
      "seo_description": "Live at The Nolan, with apartments featuring dishwashers near SEPTA Yardley Station. Modern living with transit convenience. Discover these homes today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-morrisville-pa-the-nolan-531",
      "search_query": "one bedroom apartments in Morrisville PA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Morrisville, PA",
      "h2_subtitle": "Explore one-bedroom apartments in Morrisville, PA at The Nolan, offering modern amenities and a convenient lifestyle.",
      "page_copy": "Discover the perfect one-bedroom apartment at The Nolan, situated in the charming town of Morrisville, PA. Our community offers spacious living spaces that cater to your need for comfort and convenience, from in-unit washer and dryer facilities to cable readiness. Each apartment is designed with your lifestyle in mind, providing a modern and welcoming ambiance.\n\nThe Nolan features beautifully landscaped grounds and ample parking, enhancing your everyday living experience. The community balances suburban tranquility with accessibility, making it a great choice for those seeking quality living in Bucks County. Experience the ideal blend of style and practicality by visiting The Nolan's one-bedroom apartments today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Morrisville, PA - The Nolan",
      "seo_description": "Find one-bedroom apartments at The Nolan in Morrisville, PA. Enjoy modern living with in-unit amenities and convenient location. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-bucks-county-the-nolan-400",
      "search_query": "two bedroom apartments in Bucks County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Bucks County",
      "h2_subtitle": "Discover spacious two-bedroom apartments in Bucks County at The Nolan, offering comfort and modern amenities in a serene setting.",
      "page_copy": "Welcome to The Nolan, where our two-bedroom apartments in Bucks County provide the perfect mix of space and style. Located in Morrisville, PA, our community offers a variety of modern amenities that cater to families, couples, and professionals seeking quality living.\n\nEach apartment boasts contemporary finishes, in-unit washers and dryers, and available dishwashers, making your home life convenient and comfortable. The beautifully landscaped grounds and ample parking enhance the peaceful environment. Situated within reach of local attractions and daily amenities, The Nolan is the ideal place to call home. Explore our two-bedroom options today and experience living in one of Bucks County's sought-after locations.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Bucks County - The Nolan",
      "seo_description": "Explore two-bedroom apartments at The Nolan in Bucks County. Experience spacious living with modern amenities in a tranquil setting. Visit us now!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "apartments-near-morrisville-middle-senior-high-the-nolan-881",
      "search_query": "apartments near Morrisville Middle/Senior High School Morrisville PA",
      "category": "School",
      "h1_title": "Apts Near Morrisville Middle/Senior High School",
      "h2_subtitle": "Find apartments near Morrisville Middle/Senior High School. The Nolan offers the ideal location for families in Morrisville, PA.",
      "page_copy": "The Nolan is your go-to destination for apartments near Morrisville Middle/Senior High School in Morrisville, PA. Our community provides comfortable living options, perfect for families seeking proximity to well-regarded educational institutions in the area. With spacious one and two-bedroom layouts, The Nolan ensures a convenient and enjoyable living experience.\n\nSet in beautifully landscaped surroundings, our apartments feature modern amenities such as in-unit washers and dryers, making daily life seamless for busy families. Ample parking and a park-like setting add to the appeal, while our location offers easy access to nearby schools and essential local services. Explore The Nolan today, and find an apartment that meets both your educational and lifestyle needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Morrisville Middle/Senior High - The Nolan",
      "seo_description": "Discover The Nolan's apartments near Morrisville Middle/Senior High School. Enjoy family-friendly amenities and convenient location. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "apartments-near-grandview-elementary-bucks-county-the-nolan-507",
      "search_query": "apartments close to Grandview Elementary School Bucks County",
      "category": "School",
      "h1_title": "Apts Near Grandview Elementary School, Bucks County",
      "h2_subtitle": "Discover convenience with apartments close to Grandview Elementary School in Bucks County, ideal for families seeking quality living.",
      "page_copy": "The Nolan offers an excellent choice for families looking for apartments close to Grandview Elementary School in Bucks County. Our community combines comfort with convenience, giving residents easy access to quality education and modern living. Choose from our spacious one or two-bedroom apartments designed with stylish finishes and practical amenities like in-unit washers and dryers.\n\nLocated in Morrisville, PA, The Nolan provides a park-like setting that fosters a peaceful and welcoming environment. With ample parking and cable-ready units, our community is tailored to meet your family's needs. Explore the unparalleled convenience of living near Grandview Elementary School while enjoying the comforts of home at The Nolan.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Grandview Elementary, Bucks County - The Nolan",
      "seo_description": "Explore The Nolan's apartments near Grandview Elementary School in Bucks County. Enjoy modern amenities and a family-friendly environment. Visit us now!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "rentals-near-eleanor-roosevelt-elementary-19067-the-nolan-363",
      "search_query": "rentals near Eleanor Roosevelt Elementary School 19067",
      "category": "School",
      "h1_title": "Rentals Near Eleanor Roosevelt Elementary 19067",
      "h2_subtitle": "Looking for rentals near Eleanor Roosevelt Elementary School in the 19067 area? Discover comfortable options at The Nolan in Morrisville, PA.",
      "page_copy": "At The Nolan, find the perfect rental near Eleanor Roosevelt Elementary School in the 19067 area. Families will appreciate the convenience of living close to a highly regarded school while enjoying the amenities and comforts available in our community. Choose from spacious one or two-bedroom apartments complete with modern finishes and in-unit washers and dryers.\n\nNestled in a park-like setting in Morrisville, PA, The Nolan offers a combination of peaceful living and practicality, with amenities such as ample parking and select units featuring dishwashers. Experience a lifestyle that blends accessibility with comfort and make The Nolan your next home, just moments away from Eleanor Roosevelt Elementary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Eleanor Roosevelt Elementary 19067 - The Nolan",
      "seo_description": "Discover rentals at The Nolan near Eleanor Roosevelt Elementary in the 19067 area. Enjoy spacious living and modern amenities. Visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "morrisville-apartments-near-makefield-elementary-the-nolan-181",
      "search_query": "Morrisville apartments near Makefield Elementary School",
      "category": "School",
      "h1_title": "Morrisville Apts Near Makefield Elementary School",
      "h2_subtitle": "Explore Morrisville apartments near Makefield Elementary School. The Nolan provides convenience and comfort for families seeking proximity to quality education.",
      "page_copy": "Discover the ideal living experience at The Nolan, offering Morrisville apartments near Makefield Elementary School. Perfect for families wanting to balance home comforts with accessible education, our community presents spacious one or two-bedroom layouts designed with modern amenities like in-unit washers and dryers for added convenience.\n\nSituated amidst beautifully landscaped grounds, The Nolan invites you to experience a peaceful, park-like setting complete with ample parking. This prime location ensures your family can enjoy the easy commute to Makefield Elementary School while benefiting from the premium features and pet-friendly accommodations that The Nolan offers in Morrisville, PA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Morrisville Apts Near Makefield Elementary School - The Nolan",
      "seo_description": "Find Morrisville apartments at The Nolan near Makefield Elementary School. Enjoy modern amenities and a convenient location. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "the-nolan-near-william-penn-middle-school-pa-200",
      "search_query": "the Nolan near William Penn Middle School PA",
      "category": "School",
      "h1_title": "The Nolan Near William Penn Middle School",
      "h2_subtitle": "Discover The Nolan, located conveniently near William Penn Middle School, PA. Experience quality living just a short distance from a great educational institution.",
      "page_copy": "The Nolan offers a prime location for those looking to live near William Penn Middle School in PA. Our community is perfect for families and individuals alike, providing spacious one or two-bedroom apartments with modern features and amenities such as in-unit washer and dryer facilities.\n\nSet in the charming town of Morrisville, PA, The Nolan boasts a park-like setting that enhances the living experience with beautifully landscaped grounds. Ample parking and cable-ready units cater to your modern lifestyle needs. Enjoy the comfort and convenience of living just minutes from William Penn Middle School at The Nolan.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Nolan Near William Penn Middle School, PA",
      "seo_description": "Live at The Nolan near William Penn Middle School and enjoy spacious apartments with modern amenities in Morrisville, PA. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "pennsbury-west-high-school-nearby-apartments-morrisville-158",
      "search_query": "Pennsbury West High School nearby apartments Morrisville",
      "category": "School",
      "h1_title": "Apartments Near Pennsbury West High School",
      "h2_subtitle": "Discover nearby apartments in Morrisville, close to Pennsbury West High School. The Nolan offers modern living with easy access to quality education.",
      "page_copy": "The Nolan is an excellent choice for those seeking apartments near Pennsbury West High School in Morrisville. Our community offers spacious one or two-bedroom apartments, complete with modern finishes and conveniences such as in-unit washers and dryers, making daily life easier.\n\nLocated in a serene park-like environment, The Nolan provides a peaceful setting just a short distance from Pennsbury West High School. Enjoy features like ample parking and select units with dishwashers. Experience a blend of convenience, comfort, and quality education access, right here in Morrisville, PA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pennsbury West High School - The Nolan",
      "seo_description": "Find Morrisville apartments at The Nolan near Pennsbury West High School. Enjoy spacious, modern living close to quality education. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "valley-day-school-area-apartments-bucks-county-581",
      "search_query": "Valley Day School area apartments Bucks County",
      "category": "School",
      "h1_title": "Apartments Near Valley Day School, Bucks County",
      "h2_subtitle": "Explore area apartments in Bucks County near Valley Day School. The Nolan combines modern amenities with a convenient location for families and professionals.",
      "page_copy": "Nestled in the heart of Bucks County, The Nolan offers exceptional apartments near Valley Day School. Ideal for families and individuals, our community provides one or two-bedroom options featuring modern finishes and conveniences like in-unit washers and dryers to suit your lifestyle.\n\nSituated in a tranquil, park-like setting, The Nolan enhances living with beautifully landscaped grounds. Benefit from ample parking and pet-friendly facilities, all while enjoying proximity to Valley Day School. Experience the perfect blend of contemporary living and educational accessibility in Morrisville, PA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Valley Day School, Bucks County - The Nolan",
      "seo_description": "Discover The Nolan's modern apartments in Bucks County near Valley Day School. Enjoy convenient living with top-notch amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "morrisville-rentals-near-the-montessori-school-200",
      "search_query": "Morrisville rentals near The Montessori School",
      "category": "School",
      "h1_title": "Rentals Near The Montessori School, Morrisville",
      "h2_subtitle": "Explore Morrisville rentals near The Montessori School. The Nolan offers modern living with amenities that cater to diverse lifestyle needs in a prime location.",
      "page_copy": "The Nolan presents an ideal choice for those seeking rentals near The Montessori School in Morrisville. Our community offers spacious one and two-bedroom apartments designed to meet modern living standards, complete with in-unit washer and dryer for added convenience.\n\nSituated in a beautifully landscaped environment, The Nolan combines comfort with convenience. Enjoy features such as cable-ready units and ample parking. Experience the ease of living close to The Montessori School, where quality education and an enriching community come together in Morrisville, PA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Morrisville Rentals Near The Montessori School - The Nolan",
      "seo_description": "Find modern Morrisville rentals at The Nolan near The Montessori School. Enjoy spacious living and top amenities. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "apartments-near-abrams-hebrew-academy-pa-255",
      "search_query": "apartments near Abrams Hebrew Academy PA",
      "category": "School",
      "h1_title": "Apartments Near Abrams Hebrew Academy, PA",
      "h2_subtitle": "Discover apartments in PA near Abrams Hebrew Academy. The Nolan offers modern amenities and a welcoming community in a convenient location.",
      "page_copy": "Looking for comfortable apartments near Abrams Hebrew Academy in PA? The Nolan is a premier choice for those who value proximity to quality education and modern conveniences. Our one and two-bedroom apartments provide contemporary finishes and essential amenities like in-unit washers and dryers.\n\nExperience a park-like setting with beautifully landscaped grounds perfect for relaxation and leisure. With ample parking and cable-ready units, The Nolan combines comfort and practicality. Located near Abrams Hebrew Academy, our community offers easy access to the best of Bucks County living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Abrams Hebrew Academy PA - The Nolan",
      "seo_description": "Explore The Nolan's apartments near Abrams Hebrew Academy in PA. Enjoy modern amenities convenient to top educational opportunities. Visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "bucks-county-community-college-near-the-nolan-apartments-786",
      "search_query": "Bucks County Community College near the Nolan apartments",
      "category": "School",
      "h1_title": "Near Bucks County Community College: The Nolan",
      "h2_subtitle": "Explore living options near Bucks County Community College. The Nolan offers convenience and comfort for students and professionals in the area.",
      "page_copy": "Conveniently located near Bucks County Community College, The Nolan offers the perfect setting for students, faculty, and professionals seeking quality apartments in Morrisville, PA. Choose from our spacious one or two-bedroom apartments, each featuring modern finishes and amenities like in-unit washers and dryers.\n\nThe Nolan is set within a beautifully landscaped, park-like environment, providing a serene yet practical living experience. With easy access to the college, as well as ample parking and pet-friendly options, The Nolan stands out as a premier choice for those wishing to be near academic excellence in Bucks County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bucks County Community College Near The Nolan",
      "seo_description": "Find your home at The Nolan near Bucks County Community College. Enjoy modern living with easy access to education and amenities. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "apartments-near-st-mary-medical-center-bucks-county-142",
      "search_query": "apartments near St. Mary Medical Center Bucks County",
      "category": "Hospital",
      "h1_title": "Apts Near St. Mary Medical Center, Bucks County",
      "h2_subtitle": "Discover convenient living near St. Mary Medical Center in Bucks County. The Nolan offers modern comfort in a prime location.",
      "page_copy": "For those searching for apartments near St. Mary Medical Center in Bucks County, The Nolan offers a prime solution for healthcare professionals and patients alike. Our spacious one and two-bedroom apartments are equipped with modern amenities, including in-unit washers and dryers, to enhance your living experience.\n\nNestled in a park-like setting with beautifully landscaped grounds, The Nolan provides a serene retreat with practical amenities like cable-ready units and ample parking. Located near St. Mary Medical Center, residents enjoy convenient access to healthcare services and the best of Bucks County living, making it an ideal choice for both short-term stays and long-term residency.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near St. Mary Medical Center Bucks County - The Nolan",
      "seo_description": "Choose The Nolan for modern apartments near St. Mary Medical Center in Bucks County. Enjoy convenient living with top amenities. Book a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "apartments-near-williamson-park-morrisville-pa-892",
      "search_query": "apartments near Williamson Park Morrisville PA",
      "category": "Park",
      "h1_title": "Apts Near Williamson Park, Morrisville, PA",
      "h2_subtitle": "Discover nearby apartments close to Williamson Park in Morrisville, PA. The Nolan offers modern amenities and a welcoming atmosphere.",
      "page_copy": "Looking for comfortable living options near Williamson Park in Morrisville, PA? The Nolan provides spacious one and two-bedroom apartments that combine modern finishes with exceptional amenities. Each unit comes with in-unit washers and dryers, perfect for those who value convenience.\n\nOur beautifully landscaped, park-like community not only offers ample parking and cable-ready homes but also places you within walking distance of Williamson Park. Enjoy the benefits of living close to nature while remaining connected to the vibrant Morrisville community. The Nolan is the perfect choice for anyone seeking tranquility and practicality in their living situation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Williamson Park Morrisville, PA - The Nolan",
      "seo_description": "Explore The Nolan's apartments near Williamson Park in Morrisville, PA. Enjoy modern amenities and a prime location close to local attractions. Visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "cleveland-ave-park-morrisville-apartments-393",
      "search_query": "nearby Cleveland Ave Park Morrisville apartments",
      "category": "Park",
      "h1_title": "Morrisville Apartments Near Cleveland Ave Park",
      "h2_subtitle": "Discover apartments nearby Cleveland Ave Park in Morrisville. The Nolan offers modern living in a prime location, ideal for park lovers.",
      "page_copy": "The Nolan, situated near Cleveland Ave Park in Morrisville, offers the perfect blend of modern living and accessibility to outdoor recreation. Our spacious one and two-bedroom apartments are designed with contemporary finishes, ensuring a comfortable lifestyle with the convenience of in-unit washers and dryers.\n\nEnjoy the benefits of living close to Cleveland Ave Park, where you can unwind and engage with nature. Our inviting, park-like community also provides additional amenities such as ample parking and pet-friendly options, making it an excellent choice for families and individuals who appreciate both nature and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Morrisville Apartments Near Cleveland Ave Park - The Nolan",
      "seo_description": "Find ideal Morrisville apartments near Cleveland Ave Park at The Nolan. Enjoy modern amenities and close proximity to local attractions. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "penns-grant-park-adjacent-apartments-morrisville-655",
      "search_query": "Penn’s Grant Park adjacent apartments in Morrisville",
      "category": "Park",
      "h1_title": "Apts Adjacent to Penn’s Grant Park, Morrisville",
      "h2_subtitle": "Explore apartments adjacent to Penn’s Grant Park in Morrisville. The Nolan offers modern comforts and a prime location.",
      "page_copy": "Situated in the heart of Morrisville, The Nolan provides premier living spaces adjacent to Penn’s Grant Park. Our one and two-bedroom apartments offer residents the perfect mix of modern comforts and accessibility to the great outdoors, with features like in-unit washers and dryers and select units featuring dishwashers.\n\nThe Nolan is ideal for those who enjoy the tranquility of a park-like setting while benefiting from community amenities such as ample parking and pet-friendly offerings. Being adjacent to Penn’s Grant Park ensures that green spaces and outdoor activities are just a short walk away, enriching your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Adjacent to Penn’s Grant Park, Morrisville - The Nolan",
      "seo_description": "Discover The Nolan's apartments adjacent to Penn’s Grant Park in Morrisville. Enjoy the best of modern living with easy park access. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "apartments-close-delaware-canal-ferry-road-access-pa-784",
      "search_query": "apartments close to Delaware Canal Ferry Road Access PA",
      "category": "Park",
      "h1_title": "Apts Close to Delaware Canal Ferry Road Access",
      "h2_subtitle": "Find apartments close to Delaware Canal Ferry Road access in PA. The Nolan offers proximity and modern conveniences for a perfect lifestyle.",
      "page_copy": "Discover The Nolan, where proximity meets convenience near the Delaware Canal Ferry Road access in PA. Our one and two-bedroom apartments present modern comforts like in-unit washers and dryers, perfect for a seamless living experience.\n\nSituated just a short drive from this key access point, The Nolan provides an excellent location for those seeking connectivity alongside peaceful living in a park-like setting. Enjoy nearby amenities and the ease of access that makes commuting or leisure travel simple and convenient.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts near Delaware Canal Ferry Road Access - The Nolan",
      "seo_description": "Explore The Nolan's apartments close to Delaware Canal Ferry Road access in PA. Enjoy modern amenities and a convenient location. Visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "morrisville-trailhead-delaware-canal-nearby-apartments-671",
      "search_query": "Morrisville Trailhead Delaware Canal nearby apartments",
      "category": "Park",
      "h1_title": "Nearby Apts to Morrisville Trailhead Delaware Canal",
      "h2_subtitle": "Discover apartments near the Morrisville Trailhead of the Delaware Canal. The Nolan provides the perfect blend of modern living and outdoor access.",
      "page_copy": "The Nolan is tailor-made for outdoor enthusiasts, positioned conveniently near the Morrisville Trailhead of the Delaware Canal. Our one and two-bedroom apartments boast modern amenities such as in-unit washers and dryers, making daily life smooth and comfortable.\n\nLiving near the Morrisville Trailhead means scenic walkways and nature escapes are right at your doorstep. Residents at The Nolan can enjoy ample parking, a cable-ready setup, and select units with dishwashers, all within a pet-friendly environment. Make The Nolan your home and embrace the serenity and beauty of canal-side living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts near Morrisville Trailhead Delaware Canal - The Nolan",
      "seo_description": "Find The Nolan's apartments nearby the Morrisville Trailhead Delaware Canal for modern living with easy trail access. Schedule your visit now!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "morrisville-riverfront-preserve-accessible-apartments-625",
      "search_query": "Morrisville Riverfront Preserve accessible apartments",
      "category": "Park",
      "h1_title": "Apts Accessible to Morrisville Riverfront Preserve",
      "h2_subtitle": "Enjoy apartments accessible to Morrisville Riverfront Preserve. The Nolan combines easy access with modern comforts for nature and city lovers alike.",
      "page_copy": "Welcome to The Nolan, where city living meets nature, providing ideal apartments accessible to the Morrisville Riverfront Preserve. Our one and two-bedroom apartments offer contemporary features like in-unit washers and dryers, perfect for those seeking a comfortable yet adventurous lifestyle.\n\nLocated in a prime spot, The Nolan ensures that the tranquility of the Riverfront Preserve is within easy reach. Along with this fantastic location, residents enjoy features such as ample parking, pet-friendly conveniences, and the option of cable-ready settings. Experience the best of both worlds—a vibrant community close to serene riverfront vistas.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Accessible Apts near Morrisville Riverfront Preserve - The Nolan",
      "seo_description": "Discover The Nolan's accessible apartments near Morrisville Riverfront Preserve. Enjoy convenience and nature at its best. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "morrisville-apartments-near-morrisville-dog-park-880",
      "search_query": "Morrisville apartments near Morrisville Dog Park",
      "category": "Park",
      "h1_title": "Apartments Near Morrisville Dog Park",
      "h2_subtitle": "Find Morrisville apartments near the Morrisville Dog Park. The Nolan offers pet-friendly living with modern amenities and convenient locations.",
      "page_copy": "The Nolan is ideal for pet lovers, providing Morrisville apartments near the Morrisville Dog Park. Our pet-friendly community offers spacious one and two-bedroom options equipped with modern conveniences like in-unit washers and dryers, making life with your furry friends easy and enjoyable.\n\nLocated just minutes from the Morrisville Dog Park, The Nolan ensures that you and your pet have ample space to explore and unwind. With amenities such as ample parking and cable-ready settings, you’ll have the perfect blend of active lifestyle and relaxation. Come see why The Nolan is the best place for you and your pets.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts by Morrisville Dog Park - Pet-Friendly Living at The Nolan",
      "seo_description": "Explore pet-friendly apartments near Morrisville Dog Park at The Nolan. Enjoy modern amenities and ideal location. Visit us now!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "close-to-washington-crossing-historic-park-apartments-846",
      "search_query": "close to Washington Crossing Historic Park apartments",
      "category": "Park",
      "h1_title": "Apts Close to Washington Crossing Historic Park",
      "h2_subtitle": "Discover apartments close to Washington Crossing Historic Park. The Nolan offers a perfect location with modern comforts and historic charm nearby.",
      "page_copy": "Welcome to The Nolan, a community of apartments conveniently situated close to Washington Crossing Historic Park. Our spacious one and two-bedroom units are equipped with modern amenities like in-unit washers and dryers, perfect for those who appreciate history and contemporary lifestyle.\n\nBeing close to Washington Crossing Historic Park means enjoying picturesque landscapes and rich history right in your backyard. At The Nolan, you'll benefit from amenities such as ample parking, a park-like setting, and select units with dishwashers. Embrace comfortable living with history at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Washington Crossing Historic Park - The Nolan",
      "seo_description": "Find The Nolan's apartments close to Washington Crossing Historic Park. Enjoy modern living and historic charm. Schedule your visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166354",
      "source": "custom",
      "page_item_url": "apartments-near-bowmans-hill-wildflower-preserve-923",
      "search_query": "apartments near Bowman's Hill Wildflower Preserve Bucks County",
      "category": "Park",
      "h1_title": "Apts Near Bowman's Hill Wildflower Preserve",
      "h2_subtitle": "Explore The Nolan, where apartments near Bowman's Hill Wildflower Preserve in Bucks County meet modern living. Enjoy nature and comfort together.",
      "page_copy": "The Nolan offers perfectly situated apartments near Bowman's Hill Wildflower Preserve in Bucks County. Our spacious one and two-bedroom options allow you to enjoy the natural beauty of the nearby preserve, while offering modern features such as in-unit washers and dryers for your convenience.\n\nLiving at The Nolan means having a park-like setting right at home, with easy access to the stunning native flora at Bowman's Hill Wildflower Preserve. In addition to a prime location, residents benefit from amenities like ample parking and cable-ready units. Discover comfortable living immersed in nature's beauty.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by mature trees.",
        "public_id": "01a015dc-67e9-734b-a2d0-491496eeedad",
        "storage_key": "property/6767906449166354/01a015dc-67e9-734b-a2d0-491496eeedad.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Bowman's Hill Wildflower Preserve - The Nolan",
      "seo_description": "Live near Bowman's Hill Wildflower Preserve in Bucks County at The Nolan. Enjoy nature and modern amenities. Visit us today for a tour!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5091"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976289215"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973451"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5GNJS4S6"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://thenolanapts.fatwin.com/api/websites/resources/1?x=QkJNRkkxTzRTQU9jbDFYMUdOMy9RL3h2eXZyVkorR1lwUFpYR2QyUjllanNQWHRPZFRKQzJrUzY4T01aNTd3b2RvOVpzNW5idmN2OXNoQ240aDhpWHc9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/n9w61ejrv71"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "95485ff2-43e6-11ef-85ed-0b3e4e8dce24"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95485ff2-43e6-11ef-85ed-0b3e4e8dce24/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95485ff2-43e6-11ef-85ed-0b3e4e8dce24/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ink5WjlwemxWKzhzQjU0b0RDY2RUa0E9PSIsInZhbHVlIjoic0hxWERsRkRBM3VlUGd2WlNrTVVaUT09IiwibWFjIjoiMjZjNGUzYzczN2Q4YWMxMWNkNmYzODA2MmViOWIzNjEwNjQ3YjkzNTIxZDE4MGRjMzE3MmNiNjQxZjU0OWNkMyJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5091",
  "custom_repli_id": "9976289215",
  "custom_realpage_id": "4973451",
  "custom_google_gtm_id": "GTM-5GNJS4S6",
  "custom_perq_script_url": "https://thenolanapts.fatwin.com/api/websites/resources/1?x=QkJNRkkxTzRTQU9jbDFYMUdOMy9RL3h2eXZyVkorR1lwUFpYR2QyUjllanNQWHRPZFRKQzJrUzY4T01aNTd3b2RvOVpzNW5idmN2OXNoQ240aDhpWHc9PQ2",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/n9w61ejrv71",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "95485ff2-43e6-11ef-85ed-0b3e4e8dce24",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95485ff2-43e6-11ef-85ed-0b3e4e8dce24/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95485ff2-43e6-11ef-85ed-0b3e4e8dce24/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ink5WjlwemxWKzhzQjU0b0RDY2RUa0E9PSIsInZhbHVlIjoic0hxWERsRkRBM3VlUGd2WlNrTVVaUT09IiwibWFjIjoiMjZjNGUzYzczN2Q4YWMxMWNkNmYzODA2MmViOWIzNjEwNjQ3YjkzNTIxZDE4MGRjMzE3MmNiNjQxZjU0OWNkMyJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "588b69b0-dd5a-48b6-a091-2f5fb4d765df",
  "custom_audioeye_site_hash": "1f6d97fa7b3746afb639271336e72e4d"
};

export const generatedAt = '2026-10-22T20:05:12.274Z';
